import { t as e } from "./rolldown-runtime-Dy4uBu1J.js";
import { n as t, t as n } from "./createEndpoints-BYEC3FIA.js";
import { o as ee, t as r } from "./sanitiseRequestBody-Dm5hzjxP.js";
import { t as i } from "./createQueryParams-D2aMgLX5.js";
import { t as te } from "./creditNotes.cacheKeys-CnS0uUPf.js";
import { A as ne, C as re, D as a, E as o, M as ie, O as s, S as c, T as ae, _ as l, a as u, b as oe, c as se, d as ce, f as d, g as f, h as le, i as p, j as ue, k as de, l as m, m as fe, o as h, p as g, r as _, s as v, t as y, u as pe, v as b, w as me, x as he, y as x } from "./v20240730-d4WzapES.js";
//#region src/clients/dashboard/v99990101/endpoints/products/products.cacheKeys.ts
var S = "products", ge = t({
	route: ({ id: e }) => `/products/${e}`,
	queryKey: [S],
	mocking: {
		match: /\/api\/products\/(.+)$/,
		mock: {
			id: "6007ebd9-b2ea-4764-943d-c09734f2ac6a",
			name: "Standard plan",
			label: "Standard",
			taxCategoryId: "f5930222-f2c1-42b0-884f-624aaa822edc",
			createdAt: "2023-01-11T11:47:00Z",
			updatedAt: "2024-12-21T21:47:00Z",
			revenueRecognitionMethod: "STRAIGHT_LINE",
			integrationIds: []
		}
	}
}), _e = t({
	route: (e) => `/products${i(e)}`,
	queryKey: [S],
	mocking: {
		match: /\/api\/products(\?(.*))?$/,
		mock: {
			items: [{
				id: "795447c4-82e6-46f6-ad23-9d2d9e74b347",
				name: "Standard plan",
				label: "Standard",
				taxCategoryId: "11fe86ef-8950-43ec-8ac5-805f5b52d6f1",
				createdAt: "2022-06-28T16:47:00Z",
				updatedAt: "2022-06-28T16:47:00Z",
				integrationIds: []
			}],
			pagination: {
				after: "",
				before: "",
				totalResultSize: 1
			}
		}
	}
}), ve = n({
	route: () => "/products",
	method: "POST",
	body: ({ body: e }) => JSON.stringify({
		name: e.name,
		taxCategoryId: e.taxCategoryId,
		...e.label ? { label: e.label } : {},
		...e.revenueRecognitionMethod ? { revenueRecognitionMethod: e.revenueRecognitionMethod } : {},
		...e.xeroLedgerAccountMappings === void 0 ? {} : { xeroLedgerAccountMappings: e.xeroLedgerAccountMappings }
	}),
	invalidateQueries: [S, ue],
	mocking: {
		match: /\/api\/products$/,
		mock: {
			name: "Standard plan",
			label: "Standard",
			revenueRecognitionMethod: "STRAIGHT_LINE",
			id: "b1f59f66-3fa9-471d-ba74-4cbb7ca6ea76",
			createdAt: "2024-01-01T09:00:00.000Z",
			updatedAt: "2024-02-02T09:00:00.000Z",
			integrationIds: []
		}
	}
}), ye = n({
	route: (e) => `/products/${e.id}`,
	method: "PUT",
	body: (e) => JSON.stringify(e.body),
	invalidateQueries: [S],
	mocking: {
		match: /\/api\/products\/(.+)$/,
		mock: {
			name: "Standard plan",
			label: "Standard",
			taxCategoryId: "829f6ecf-9e99-4126-8f88-68e0593524c5",
			id: "9a343654-1488-4998-af5e-9d0e2735020e",
			createdAt: "2023-01-11T11:47:00Z",
			updatedAt: "2024-12-21T21:47:00Z",
			revenueRecognitionMethod: "STRAIGHT_LINE",
			integrationIds: []
		}
	}
}), C = "taxCategories", be = t({
	route: (e) => `/tax-categories${i(e)}`,
	queryKey: [C],
	mocking: {
		match: /\/api\/tax-categories(\?(.*))?$/,
		mock: {
			items: [{
				id: "3271ca41-d538-404f-a15f-25856a37fb88",
				versionId: "82ef6f1a-afc2-4a8d-b868-6d9c72bf395f",
				version: 0,
				isPublished: !1,
				name: "EU Sales Taxes",
				description: "All sales taxes required for the EU",
				isDefault: !0,
				taxRates: []
			}],
			pagination: {
				after: "",
				before: "",
				totalResultSize: 1
			}
		}
	}
}), w = "taxRates", xe = t({
	route: (e) => `/tax-rates${i(e)}`,
	queryKey: [w],
	mocking: {
		match: /\/api\/tax-rates(\?(.*))?$/,
		mock: {
			items: [{
				id: "d58bf2e3-7a5d-4900-8457-2521c6880f7d",
				versionId: "82ef6f1a-afc2-4a8d-b868-6d9c72bf395f",
				version: 0,
				isPublished: !1,
				name: "UK Sales Tax",
				invoiceName: "Value Added Tax",
				invoiceShortName: "VAT",
				amount: "0.2",
				country: "GB",
				taxCategoryId: "ce109c64-dcc0-487a-ac8c-e3237c60cdb6",
				isArchived: !1
			}],
			pagination: {
				after: "",
				before: "",
				totalResultSize: 1
			}
		}
	}
}), Se = n({
	route: () => "/tax-categories",
	method: "POST",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [C, w],
	mocking: {
		match: /\/api\/tax-categories$/,
		mock: {
			id: "3271ca41-d538-404f-a15f-25856a37fb88",
			versionId: "82ef6f1a-afc2-4a8d-b868-6d9c72bf395f",
			version: 0,
			isPublished: !1,
			name: "EU Sales Taxes",
			description: "All sales taxes required for the EU",
			taxRates: [],
			isDefault: !1
		}
	}
}), Ce = n({
	route: ({ id: e }) => `/tax-categories/${e}/versions`,
	method: "POST",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [C, w],
	mocking: {
		match: /\/api\/tax-categories\/(.+)\/versions$/,
		mock: {
			id: "3271ca41-d538-404f-a15f-25856a37fb88",
			versionId: "82ef6f1a-afc2-4a8d-b868-6d9c72bf395f",
			version: 1,
			isPublished: !0,
			name: "EU Sales Taxes",
			description: "All sales taxes required for the EU",
			taxRates: [],
			isDefault: !1
		}
	}
}), we = n({
	route: ({ id: e }) => `/tax-categories/${e}/make-default`,
	method: "POST",
	invalidateQueries: [C],
	mocking: {
		match: /\/api\/tax-categories\/(.+)\/make-default$/,
		mock: {
			id: "3271ca41-d538-404f-a15f-25856a37fb88",
			versionId: "82ef6f1a-afc2-4a8d-b868-6d9c72bf395f",
			version: 0,
			isPublished: !1,
			name: "EU Sales Taxes",
			description: "All sales taxes required for the EU",
			isDefault: !0,
			taxRates: []
		}
	}
}), Te = n({
	route: () => "/tax-rates",
	body: ({ body: e }) => JSON.stringify(e),
	method: "POST",
	invalidateQueries: [w, C],
	mocking: {
		match: /\/api\/tax-rates$/,
		mock: {
			id: "d58bf2e3-7a5d-4900-8457-2521c6880f7d",
			versionId: "82ef6f1a-afc2-4a8d-b868-6d9c72bf395f",
			version: 0,
			isPublished: !1,
			name: "UK Sales Tax",
			invoiceName: "Value Added Tax",
			invoiceShortName: "VAT",
			description: "Value Added Tax applied to sales in the UK",
			amount: "0.2",
			country: "GB",
			taxCategoryId: "ce109c64-dcc0-487a-ac8c-e3237c60cdb6",
			isArchived: !1
		}
	}
}), Ee = n({
	route: ({ id: e }) => `/tax-rates/${e}/versions`,
	body: ({ body: e }) => JSON.stringify(e),
	method: "POST",
	invalidateQueries: [w, C],
	mocking: {
		match: /\/api\/tax-rates\/(.+)\/versions$/,
		mock: {
			id: "d58bf2e3-7a5d-4900-8457-2521c6880f7d",
			versionId: "82ef6f1a-afc2-4a8d-b868-6d9c72bf395f",
			version: 1,
			isPublished: !1,
			name: "UK Sales Tax",
			invoiceName: "Value Added Tax",
			invoiceShortName: "VAT",
			description: "Value Added Tax applied to sales in the UK",
			amount: "0.2",
			country: "GB",
			taxCategoryId: "ce109c64-dcc0-487a-ac8c-e3237c60cdb6",
			isArchived: !1
		}
	}
}), T = "journals", De = "accountingPeriods", E = "chartsData", D = "deferredRevenueSchedules", Oe = "revenueRecognitionOverview", ke = "revenueWaterfallData", O = "revenueWaterfallDownload", Ae = "xeroRecognitionSyncStatus", je = t({
	route: (e) => `/revenue/journals/${e.id}`,
	queryKey: [T],
	mocking: {
		match: /\/api\/revenue\/journals\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/,
		mock: {
			id: "3f9a90d2-37fd-41c7-11fa-3d5f82bb9bea",
			journalType: "SYSTEM",
			ledgerId: "ec30d4ba-213d-4435-abf7-fe829b7ecb03",
			narrative: "Journal narrative",
			date: "2021-01-01",
			product: {
				id: "3f9a90d2-37fd-41c7-11fa-3d5f82bb9bea",
				name: "Platform Access"
			},
			customer: {
				id: "3f9a90d2-37fd-41c7-11fa-3d5f82bb9bea",
				name: "ACME Inc."
			},
			invoice: {
				id: "9724073f-675b-434a-9004-2119a9541c3c",
				name: "INV-003"
			},
			entries: [{
				id: "3d1bcf09-409a-495d-959b-12eebfc20e0d",
				journalId: "3f9a90d2-37fd-41c7-11fa-3d5f82bb9bea",
				account: {
					id: "a8639230-5594-4f10-bc56-70edbb6c9e08",
					name: "DEFERRED_REVENUE"
				},
				direction: "DEBIT",
				amount: 100
			}, {
				id: "3d1bcf09-409a-495d-959b-12eebfc20e0d",
				journalId: "3f9a90d2-37fd-41c7-11fa-3d5f82bb9bea",
				account: {
					id: "a8639230-5594-4f10-bc56-70edbb6c9e08",
					name: "RECOGNIZED_REVENUE"
				},
				direction: "CREDIT",
				amount: 100
			}],
			createdAt: "2021-01-01T00:00:00Z"
		}
	}
}), Me = t({
	route: () => "/revenue/accounting-periods",
	queryKey: [De],
	mocking: {
		match: /\/api\/revenue\/accounting-periods(\?(.*))?$/,
		mock: { items: [{
			id: "bb1190d2-3f9a-41c7-00ea-5f8237fdfa9b",
			accountingPeriod: {
				start: "2022-06-01",
				endInclusive: "2022-06-30"
			},
			createdAt: "2022-06-28T16:47:00Z"
		}] }
	}
}), Ne = t({
	route: () => "/revenue/ledgers",
	queryKey: [T],
	mocking: {
		match: /\/api\/revenue\/ledgers$/,
		mock: { items: [{
			id: "37fd90d2-3f9a-41c7-9bea-3d5f82bb11fa",
			currency: "GBP",
			accounts: [{
				id: "3f9a90d2-37fd-41c7-11fa-3d5f82bb9bea",
				ledgerId: "37fd90d2-3f9a-41c7-9bea-3d5f82bb11fa",
				name: "RECOGNIZED_REVENUE",
				balanceType: "CREDIT",
				createdAt: "2022-06-28T16:47:00Z"
			}],
			createdAt: "2022-06-28T16:47:00Z"
		}] }
	}
}), Pe = t({
	route: (e) => `/revenue/ledgers/${e.id}`,
	queryKey: [T],
	mocking: {
		match: /\/api\/revenue\/ledgers\/(.+)$/,
		mock: {
			id: "37fd90d2-3f9a-41c7-9bea-3d5f82bb11fa",
			currency: "GBP",
			accounts: [{
				id: "3f9a90d2-37fd-41c7-11fa-3d5f82bb9bea",
				ledgerId: "37fd90d2-3f9a-41c7-9bea-3d5f82bb11fa",
				name: "RECOGNIZED_REVENUE",
				balanceType: "CREDIT",
				createdAt: "2022-06-28T16:47:00Z"
			}],
			createdAt: "2022-06-28T16:47:00Z"
		}
	}
}), Fe = t({
	route: (e) => `/revenue/charts-data${i(e)}`,
	queryKey: [E],
	mocking: {
		match: /\/api\/revenue\/charts-data(\?(.*))?$/,
		mock: { period: {
			startDate: "2023-10-01",
			endDate: "2023-12-31",
			totals: {
				recognizedAndDeferred: 24e6,
				billedAndUnbilled: 24e6
			},
			buckets: [
				{
					month: 10,
					year: 2023,
					recognizedAndDeferred: {
						total: 0,
						ledgerAccountTotals: [{
							id: "3f9a90d2-37fd-41c7-11fa-3d5f82bb9bea",
							name: "RECOGNIZED_REVENUE",
							total: 0
						}, {
							id: "3f9a90d2-37fd-41c7-11fa-3d5f82bb9bea",
							name: "DEFERRED_REVENUE",
							total: 0
						}]
					},
					billedAndUnbilled: {
						total: 0,
						ledgerAccountTotals: [{
							id: "3f9a90d2-37fd-41c7-11fa-3d5f82bb9bea",
							name: "BILLED_REVENUE",
							total: 0
						}, {
							id: "3f9a90d2-37fd-41c7-11fa-3d5f82bb9bea",
							name: "UNBILLED_REVENUE",
							total: 0
						}]
					}
				},
				{
					month: 11,
					year: 2023,
					recognizedAndDeferred: {
						total: 0,
						ledgerAccountTotals: [{
							id: "3f9a90d2-37fd-41c7-11fa-3d5f82bb9bea",
							name: "RECOGNIZED_REVENUE",
							total: 0
						}, {
							id: "3f9a90d2-37fd-41c7-11fa-3d5f82bb9bea",
							name: "DEFERRED_REVENUE",
							total: 0
						}]
					},
					billedAndUnbilled: {
						total: 0,
						ledgerAccountTotals: [{
							id: "3f9a90d2-37fd-41c7-11fa-3d5f82bb9bea",
							name: "BILLED_REVENUE",
							total: 0
						}, {
							id: "3f9a90d2-37fd-41c7-11fa-3d5f82bb9bea",
							name: "UNBILLED_REVENUE",
							total: 0
						}]
					}
				},
				{
					month: 12,
					year: 2023,
					recognizedAndDeferred: {
						total: 2e6,
						ledgerAccountTotals: [{
							id: "3f9a90d2-37fd-41c7-11fa-3d5f82bb9bea",
							name: "RECOGNIZED_REVENUE",
							total: 15e5
						}, {
							id: "3f9a90d2-37fd-41c7-11fa-3d5f82bb9bea",
							name: "DEFERRED_REVENUE",
							total: 5e5
						}]
					},
					billedAndUnbilled: {
						total: 2e6,
						ledgerAccountTotals: [{
							id: "3f9a90d2-37fd-41c7-11fa-3d5f82bb9bea",
							name: "BILLED_REVENUE",
							total: 5e5
						}, {
							id: "3f9a90d2-37fd-41c7-11fa-3d5f82bb9bea",
							name: "UNBILLED_REVENUE",
							total: 15e5
						}]
					}
				}
			]
		} }
	}
}), Ie = n({
	route: () => "/revenue/journal-reports",
	body: (e) => JSON.stringify(e),
	method: "POST",
	invalidateQueries: [],
	mocking: {
		match: /\/api\/revenue\/journal-reports$/,
		mock: void 0,
		status: 202
	}
}), Le = n({
	route: () => "/revenue/journal-pushes/xero",
	body: (e) => JSON.stringify(e),
	method: "POST",
	invalidateQueries: [],
	mocking: {
		match: /\/api\/revenue\/journal-pushes\/xero$/,
		mock: void 0,
		status: 202
	}
}), Re = t({
	route: (e) => `/revenue/journal-pushes/xero/sync-status${i(e)}`,
	queryKey: [Ae],
	mocking: {
		match: /\/api\/revenue\/journal-pushes\/xero\/sync-status(\?(.*))?$/,
		mock: { months: [
			{
				year: 2026,
				month: 6,
				pending: 0,
				posting: 0,
				posted: 3,
				failed: 0,
				lastSyncedAt: "2026-06-30T09:15:00Z"
			},
			{
				year: 2026,
				month: 5,
				pending: 2,
				posting: 0,
				posted: 4,
				failed: 0,
				lastSyncedAt: "2026-05-31T09:15:00Z"
			},
			{
				year: 2026,
				month: 4,
				pending: 0,
				posting: 0,
				posted: 0,
				failed: 2,
				lastSyncedAt: null
			}
		] }
	}
}), ze = n({
	route: () => "/revenue/analysis-reports",
	body: (e) => JSON.stringify(e),
	method: "POST",
	invalidateQueries: [],
	mocking: {
		match: /\/api\/revenue\/analysis-reports$/,
		mock: void 0,
		status: 202
	}
}), Be = t({
	route: ({ signature: e }) => `/revenue/analysis-reports/download?signature=${encodeURIComponent(e)}`,
	queryKey: ["analysisReportSignedDownload"],
	mocking: {
		match: /\/api\/revenue\/analysis-reports\/download\?signature=/,
		mock: { url: "https://cdn.example.com/analysis-report.xlsx" }
	}
}), Ve = n({
	route: () => "/revenue/deferred-revenue-schedule-reports",
	body: (e) => JSON.stringify(e),
	method: "POST",
	invalidateQueries: [],
	mocking: {
		match: /\/api\/revenue\/deferred-revenue-schedule-reports$/,
		mock: void 0,
		status: 202
	}
}), He = t({
	route: ({ signature: e }) => `/revenue/deferred-revenue-schedule-reports/download?signature=${encodeURIComponent(e)}`,
	queryKey: ["deferredRevenueScheduleSignedDownload"],
	mocking: {
		match: /\/api\/revenue\/deferred-revenue-schedule-reports\/download\?signature=/,
		mock: { url: "https://cdn.example.com/deferred-revenue-schedule.csv" }
	}
}), k = "avalaraCompanies", A = "avalaraTaxCategoryMappings", j = "avalaraCredentials", Ue = "avalaraTaxCodeInfo", We = t({
	route: () => "/tax/avalara/companies",
	queryKey: [k],
	mocking: {
		match: /\/api\/tax\/avalara\/companies$/,
		mock: { items: [{
			id: "a123",
			companyId: "avalara-01",
			companyName: "Avalara Company 1",
			createdAt: "2024-09-25T12:34:56Z",
			isEnabled: !0
		}, {
			id: "a124",
			companyId: "avalara-02",
			companyName: "Avalara Company 2",
			createdAt: "2024-09-25T12:35:00Z",
			isEnabled: !1
		}] }
	}
}), M = "enabledTaxIntegration", Ge = t({
	route: () => "/tax/integration",
	queryKey: [M],
	mocking: {
		match: /\/api\/tax\/integration$/,
		mock: {
			sequenceAccountId: "string",
			taxIntegrationProvider: "SEQUENCE"
		}
	}
}), Ke = n({
	route: () => "/tax/integration",
	method: "PUT",
	body: ({ taxIntegrationProvider: e }) => JSON.stringify({ taxIntegrationProvider: e }),
	invalidateQueries: [M],
	mocking: {
		match: /\/api\/tax\/integration$/,
		mock: {
			sequenceAccountId: "string",
			taxIntegrationProvider: "NUMERAL"
		}
	}
}), qe = t({
	route: () => "/tax/avalara/tax-categories/mappings",
	queryKey: [A],
	mocking: {
		match: /\/api\/tax\/avalara\/tax-categories\/mappings$/,
		mock: { items: [{
			taxCategoryId: "txc_123456",
			taxCategoryName: "Standard Rate",
			avalaraTaxCode: "P0000000",
			taxName: "General Sales and Use Tax"
		}, {
			taxCategoryId: "txc_789012",
			taxCategoryName: "Zero Rate",
			avalaraTaxCode: "NT",
			taxName: "Nontaxable"
		}] }
	}
}), Je = n({
	route: () => "/tax/avalara/tax-categories/mappings",
	method: "POST",
	body: (e) => JSON.stringify(e),
	invalidateQueries: [A],
	mocking: {
		match: /\/api\/tax\/avalara\/tax-categories\/mappings$/,
		mock: {
			taxCategoryId: "txc_123456",
			taxCategoryName: "Standard Rate",
			avalaraTaxCode: "P0000000",
			taxName: "General Sales and Use Tax"
		}
	}
}), Ye = n({
	route: ({ id: e }) => `/tax/avalara/tax-categories/${e}/mappings`,
	method: "DELETE",
	invalidateQueries: [A],
	mocking: {
		match: /\/api\/tax\/avalara\/tax-categories\/(.+)\/mappings$/,
		mock: void 0
	}
}), Xe = n({
	route: ({ id: e }) => `/tax/avalara/companies/${e}/enable`,
	method: "POST",
	invalidateQueries: [k],
	mocking: {
		match: /\/api\/tax\/avalara\/companies\/(.+)\/enable$/,
		mock: { items: [{
			id: "avc_123456",
			companyId: "cmp_789012",
			companyName: "Test Company",
			createdAt: "2024-09-27T12:00:00Z",
			isEnabled: !0
		}] }
	}
}), Ze = n({
	route: () => "/tax/avalara/companies",
	method: "POST",
	body: ({ accountId: e, licenseKey: t }) => JSON.stringify({
		accountId: e,
		licenseKey: t
	}),
	invalidateQueries: [k],
	mocking: {
		match: /\/api\/tax\/avalara\/companies$/,
		mock: { items: [{
			id: "avc_123456",
			companyId: "cmp_789012",
			companyName: "Test Company",
			createdAt: "2024-09-27T12:00:00Z",
			isEnabled: !0
		}] }
	}
}), Qe = n({
	route: () => "/tax/avalara/credentials",
	method: "POST",
	body: (e) => JSON.stringify(e),
	invalidateQueries: [
		j,
		k,
		A
	],
	mocking: {
		match: /\/api\/tax\/avalara\/credentials$/,
		mock: {
			accountId: "abc123",
			obfuscatedLicenseKey: "****************eKey"
		}
	}
}), $e = t({
	route: () => "/tax/avalara/credentials",
	queryKey: [j],
	mocking: {
		match: /\/api\/tax\/avalara\/credentials$/,
		mock: {
			accountId: "abc123",
			obfuscatedLicenseKey: "****************eKey"
		}
	}
}), N = "numeralCredentials", P = "numeralTaxCategoryMappings", et = "numeralTaxCategories", tt = n({
	route: () => "/tax/numeral/credentials/test",
	method: "POST",
	body: ({ apiKey: e }) => JSON.stringify({ apiKey: e }),
	invalidateQueries: [N],
	mocking: {
		match: /\/api\/tax\/numeral\/credentials\/test$/,
		mock: {
			isValid: !0,
			environment: "test",
			apiVersion: "1.0"
		}
	}
}), nt = n({
	route: () => "/tax/numeral/credentials",
	method: "POST",
	body: (e) => JSON.stringify(e),
	invalidateQueries: [N],
	mocking: {
		match: /\/api\/tax\/numeral\/credentials$/,
		mock: { obfuscatedApiKey: "****************Key" }
	}
}), rt = t({
	route: () => "/tax/numeral/credentials",
	queryKey: [N],
	mocking: {
		match: /\/api\/tax\/numeral\/credentials$/,
		mock: { obfuscatedApiKey: "****************Key" }
	}
}), F = "sphereCredentials", it = n({
	route: () => "/tax/sphere/credentials/test",
	method: "POST",
	body: ({ apiKey: e }) => JSON.stringify({ apiKey: e }),
	invalidateQueries: [F],
	mocking: {
		match: /\/api\/tax\/sphere\/credentials\/test$/,
		mock: { isValid: !0 }
	}
}), at = n({
	route: () => "/tax/sphere/credentials",
	method: "POST",
	body: (e) => JSON.stringify(e),
	invalidateQueries: [F],
	mocking: {
		match: /\/api\/tax\/sphere\/credentials$/,
		mock: { obfuscatedApiKey: "****************Key" }
	}
}), ot = t({
	route: () => "/tax/sphere/credentials",
	queryKey: [F],
	mocking: {
		match: /\/api\/tax\/sphere\/credentials$/,
		mock: { obfuscatedApiKey: "****************Key" }
	}
}), I = "anrokCredentials", st = "ANROK_TAX_CATEGORIES", L = "ANROK_TAX_CATEGORY_MAPPINGS", ct = n({
	route: () => "/tax/anrok/credentials/test",
	method: "POST",
	body: ({ apiKey: e }) => JSON.stringify({ apiKey: e }),
	invalidateQueries: [I],
	mocking: {
		match: /\/api\/tax\/anrok\/credentials\/test$/,
		mock: { isValid: !0 }
	}
}), lt = n({
	route: () => "/tax/anrok/credentials",
	method: "POST",
	body: (e) => JSON.stringify(e),
	invalidateQueries: [I],
	mocking: {
		match: /\/api\/tax\/anrok\/credentials$/,
		mock: { obfuscatedApiKey: "****************Key" }
	}
}), ut = t({
	route: () => "/tax/anrok/credentials",
	queryKey: [I],
	mocking: {
		match: /\/api\/tax\/anrok\/credentials$/,
		mock: { obfuscatedApiKey: "****************Key" }
	}
}), R = "rilletCredentials", dt = "rilletWebhookToken", ft = n({
	route: () => "/rillet/credentials/validate",
	method: "POST",
	body: ({ apiKey: e }) => JSON.stringify({ apiKey: e }),
	invalidateQueries: [R],
	mocking: {
		match: /\/api\/rillet\/credentials\/validate$/,
		mock: { isValid: !0 }
	}
}), pt = n({
	route: () => "/rillet/credentials",
	method: "POST",
	body: (e) => JSON.stringify(e),
	invalidateQueries: [R],
	mocking: {
		match: /\/api\/rillet\/credentials$/,
		mock: { maskedApiKey: { maskedString: "****************Key" } }
	}
}), mt = t({
	route: () => "/rillet/credentials",
	queryKey: [R],
	mocking: {
		match: /\/api\/rillet\/credentials$/,
		mock: { maskedApiKey: { maskedString: "****************Key" } }
	}
}), ht = n({
	route: () => "/rillet/webhook/secret",
	method: "PUT",
	body: (e) => JSON.stringify(e),
	invalidateQueries: [dt],
	mocking: {
		match: /\/api\/rillet\/webhook\/secret$/,
		mock: { maskedWebhookSecret: { maskedString: "****************" } }
	}
}), gt = t({
	route: () => "/rillet/webhook/secret",
	queryKey: [dt],
	mocking: {
		match: /\/api\/rillet\/webhook\/secret$/,
		mock: { maskedWebhookSecret: { maskedString: "****************" } }
	}
}), _t = "quoteAnalytics", vt = n({
	route: ({ dealId: e }) => `/hubspot/deals/${encodeURIComponent(e)}/quote`,
	method: "POST",
	body: ({ portalId: e, companyId: t }) => JSON.stringify({
		portalId: e,
		companyId: t
	}),
	invalidateQueries: ["quotes"],
	mocking: {
		match: /\/api\/hubspot\/deals\/(.+)\/quote$/,
		mock: {
			quoteId: "01849e70-703e-705a-b59a-d3fd575587e0",
			outcome: "CREATED"
		}
	}
}), yt = t({
	route: () => "/tax/numeral/tax-categories/mappings",
	queryKey: [P],
	mocking: {
		match: /\/api\/tax\/numeral\/tax-categories\/mappings$/,
		mock: { items: [
			{
				taxCategoryId: "txc_123456",
				taxCategoryName: "Standard Rate",
				isDefault: !0,
				numeralProductCategory: "GENERAL_MERCHANDISE",
				numeralProductCategoryTitle: "General Merchandise"
			},
			{
				taxCategoryId: "txc_789012",
				taxCategoryName: "Zero Rate",
				isDefault: !1,
				numeralProductCategory: "EXEMPT",
				numeralProductCategoryTitle: "Exempt"
			},
			{
				taxCategoryId: "txc_345678",
				taxCategoryName: "Reduced Rate",
				isDefault: !1,
				numeralProductCategory: "FOOD_GENERAL",
				numeralProductCategoryTitle: "Food General"
			}
		] }
	}
}), bt = t({
	route: () => "/tax/numeral/product-categories",
	queryKey: [et],
	mocking: {
		match: /\/api\/tax\/numeral\/product-categories$/,
		mock: { items: /* @__PURE__ */ "BEER.BEVERAGE_BOTTLED_WATER.BEVERAGE_CARBONATED.BEVERAGE_COFFEE_TEA.BEVERAGE_FRUIT_JUICE_100_PERCENT.BEVERAGE_MILK.BEVERAGE_SOFT_DRINK.BOOKS.BOOKS_DIGITAL_ACCESS.BOOKS_DIGITAL_DOWNLOAD.CBD.CIGARETTE_ELECTRONIC.CIGARETTE_PACK.CIGARS.CLOTHING_GENERAL.CLOTHING_ATHLETIC.CLOTHING_JEWELRY.DIGITAL_AUDIO_STREAMED.DIGITAL_VIDEO_STREAMED.EVENT_TICKETS.EXEMPT.FOOD_GENERAL.FOOD_CANDY.FOOD_ICECREAM.FOOD_PREPAREDFOODS.GENERAL_MERCHANDISE.GIFT_CARDS.HOME_BABY_GENERAL.HOME_PERSONAL_CARE.HOME_PAPER_GOODS.HOME_MEDICALDEVICE.MAGAZINE.NEWSPAPER.PET_FOOD.PRESCRIPTION_MEDS.SAAS_GENERAL.SOFTWARE_DOWNLOAD.SUPPLEMENTS_GENERAL.TOBACCO_CIGARETTE.TOBACCO_SMOKING.SHIPPING".split(".") }
	}
}), xt = n({
	route: () => "/tax/numeral/tax-categories/mappings",
	method: "POST",
	body: (e) => JSON.stringify(e),
	invalidateQueries: [P],
	mocking: {
		match: /\/api\/tax\/numeral\/tax-categories\/mappings$/,
		mock: {
			taxCategoryId: "txc_123456",
			taxCategoryName: "Standard Rate",
			isDefault: !1,
			numeralProductCategory: "GENERAL_MERCHANDISE",
			numeralProductCategoryTitle: "General Merchandise"
		}
	}
}), St = n({
	route: ({ taxCategoryId: e }) => `/tax/numeral/tax-categories/${e}/mappings`,
	method: "PUT",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [P],
	mocking: {
		match: /\/api\/tax\/numeral\/tax-categories\/(.+)\/mappings$/,
		mock: {
			taxCategoryId: "txc_123456",
			taxCategoryName: "Standard Rate",
			isDefault: !1,
			numeralProductCategory: "GENERAL_MERCHANDISE",
			numeralProductCategoryTitle: "General Merchandise"
		}
	}
}), Ct = n({
	route: (e) => `/tax/numeral/tax-categories/${e}/mappings`,
	method: "DELETE",
	invalidateQueries: [P],
	mocking: {
		match: /\/api\/tax\/numeral\/tax-categories\/(.+)\/mappings$/,
		mock: void 0
	}
}), wt = t({
	route: () => "/tax/anrok/tax-categories/mappings",
	queryKey: [L],
	mocking: {
		match: /\/api\/tax\/anrok\/tax-categories\/mappings$/,
		mock: { items: [{
			taxCategoryId: "txc_anrok_1",
			taxCategoryName: "Software",
			isDefault: !0,
			anrokProductExternalId: "ext_1",
			anrokTaxCategoryId: "saas-business",
			anrokTaxCategoryType: "standard"
		}] }
	}
}), Tt = t({
	route: () => "/tax/anrok/tax-categories",
	queryKey: [st],
	mocking: {
		match: /\/api\/tax\/anrok\/tax-categories$/,
		mock: { items: [
			{
				id: "saas-business",
				type: "standard",
				name: "SaaS - Business"
			},
			{
				id: "professional-services",
				type: "standard",
				name: "Professional Services"
			},
			{
				id: "software-license",
				type: "standard",
				name: "Software License"
			}
		] }
	}
}), Et = n({
	route: () => "/tax/anrok/tax-categories/mappings",
	method: "POST",
	body: (e) => JSON.stringify(e),
	invalidateQueries: [L],
	mocking: {
		match: /\/api\/tax\/anrok\/tax-categories\/mappings$/,
		mock: {
			taxCategoryId: "txc_anrok_1",
			taxCategoryName: "Software",
			anrokProductExternalId: "01961234-5678-7000-8000-abcdef123456",
			isDefault: !1,
			anrokTaxCategoryId: "saas-business",
			anrokTaxCategoryType: "standard"
		}
	}
}), Dt = n({
	route: ({ taxCategoryId: e }) => `/tax/anrok/tax-categories/${e}/mappings`,
	method: "PUT",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [L],
	mocking: {
		match: /\/api\/tax\/anrok\/tax-categories\/(.+)\/mappings$/,
		mock: {
			taxCategoryId: "txc_anrok_1",
			taxCategoryName: "Software",
			anrokProductExternalId: "01961234-5678-7000-8000-abcdef123456",
			isDefault: !1,
			anrokTaxCategoryId: "saas-business",
			anrokTaxCategoryType: "standard"
		}
	}
}), Ot = n({
	route: (e) => `/tax/anrok/tax-categories/${e}/mappings`,
	method: "DELETE",
	invalidateQueries: [L],
	mocking: {
		match: /\/api\/tax\/anrok\/tax-categories\/(.+)\/mappings$/,
		mock: void 0
	}
}), kt = t({
	route: ({ taxCode: e }) => `/tax/avalara/tax-code/${e}`,
	queryKey: [Ue],
	mocking: {
		match: /\/api\/tax\/avalara\/tax-code\/(.+)$/,
		mock: {
			title: "P0000000",
			description: "General Sales and Use Tax"
		}
	}
}), At = t({
	route: (e) => `/revenue/deferred-revenue-schedules/${e.id}`,
	queryKey: [D],
	mocking: {
		match: /\/api\/revenue\/deferred-revenue-schedules\/(?!paginated)(.+)$/,
		mock: {
			id: "0ac3bae9-285a-40bc-905c-56eef982fd37",
			customer: {
				id: "1652e492-3227-4291-ae05-e7d8697b84d1",
				name: "Loom Inc",
				domain: "loom.com"
			},
			product: {
				id: "40a0ecbd-a7e6-440d-963c-aa2728b1541b",
				name: "Platform Access"
			},
			invoice: {
				id: "dcd7a52d-930f-4051-a418-38fac9a1b730",
				name: "INV00023"
			},
			progress: {
				currency: "GBP",
				original: "8000.00",
				recognized: "6400.00",
				remaining: "1600.00",
				details: [
					{
						date: "2024-01-01",
						balance: "8000.00"
					},
					{
						date: "2024-09-27",
						balance: "1200.00"
					},
					{
						date: "2024-12-31",
						balance: "0.00"
					}
				]
			},
			recognitionTerm: {
				start: "2024-01-01",
				endInclusive: "2024-12-31"
			},
			recognitionMethod: "STRAIGHT_LINE"
		}
	}
}), jt = n({
	route: (e) => `/revenue/journals/deferred-revenue-schedules/milestone/${e.scheduleId}/recognize`,
	body: (e) => JSON.stringify({
		narrative: e.narrative,
		date: e.date,
		amount: e.amount
	}),
	method: "POST",
	invalidateQueries: [
		T,
		D,
		E
	],
	mocking: {
		match: /\/api\/revenue\/journals\/deferred-revenue-schedules\/milestone\/(.+)\/recognize$/,
		mock: {
			id: "0ac3bae9-285a-40bc-905c-56eef982fd37",
			customer: {
				id: "1652e492-3227-4291-ae05-e7d8697b84d1",
				name: "Mayo Clinic"
			},
			product: {
				id: "40a0ecbd-a7e6-440d-963c-aa2728b1541b",
				name: "Platform Access"
			},
			invoice: {
				id: "dcd7a52d-930f-4051-a418-38fac9a1b730",
				name: "INV00023"
			},
			progress: {
				currency: "GBP",
				original: "5000.00",
				recognized: "0.00",
				remaining: "5000.00",
				details: [{
					date: "2024-02-14",
					balance: "5000.00"
				}]
			},
			recognitionMethod: "MILESTONE"
		}
	}
}), Mt = t({
	route: ({ id: e }) => `/credit-notes/${e}`,
	queryKey: [g],
	mocking: {
		match: /\/api\/credit-notes\/([^\/]+?)$/,
		mock: {
			id: "af60cab3-812d-4250-a051-0fb7133a00c7",
			status: "DRAFT",
			invoiceId: "af60cab3-812d-4250-a051-0fb7133a00c7",
			invoiceNumber: "INV00001",
			billingScheduleId: "fe2fcd0b-4c53-45c7-b2ae-b6c1a7d21e95",
			currency: "GBP",
			issueDate: "2022-09-15",
			accountingDate: "2022-09-15",
			billingPeriodStart: "2022-10-01T00:00:00Z",
			billingPeriodEnd: "2022-10-30T00:00:00Z",
			creditNoteNumber: "CN00001",
			purchaseOrderNumber: "PO123",
			customerId: "61b083e0-1faa-47ca-9aeb-6205da8f6c47",
			customerEmails: ["customer@example.com", "customer.alias@example.com"],
			customerLegalCompanyName: "Facebook",
			customerBillingAddress: {
				line1: "Flat 1",
				line2: "15 Yemen Road",
				town: "Yemen",
				state: "CA",
				postcode: "YE1 2YE",
				country: "US"
			},
			customerShippingAddress: {
				line1: "742 Evergreen Terrace",
				town: "Springfield",
				state: "CA",
				postcode: "12345",
				country: "US"
			},
			memo: "Thanks",
			totalTax: "800.00",
			netTotal: "6000.00",
			grossTotal: "6800.00",
			metadata: [{
				key: "example-label",
				value: "label-value"
			}],
			customerTaxId: "TAX123",
			linkedServices: [{
				externalId: "123",
				externalService: "Xero",
				syncTime: "2022-06-28T16:47:00Z"
			}],
			merchantDetails: {
				address: {
					line1: "The White House",
					line2: "1600 Pennsylvania Avenue",
					town: "Washington, D.C.",
					state: "CA",
					postcode: "20500",
					country: "US"
				},
				phoneNumber: "0800001066",
				email: "donald@example.com",
				taxId: "TAX60",
				iban: "GB33BUKB20201555555555",
				ukAccountDetails: {
					sortCode: "000000",
					accountNumber: "12345678"
				},
				usAchDetails: {
					accountNumber: "12345678",
					accountName: "John Doe",
					bankName: "Chase",
					bankRoutingNumber: "123456789"
				},
				usWireDetails: {
					accountNumber: "12345678",
					accountName: "John Doe",
					bankName: "Chase",
					bankRoutingNumber: "123456789",
					swiftCode: "CHASUS33",
					bankAddress: {
						line1: "JP Morgan Chase",
						town: "New York City",
						state: "NY",
						postcode: "10017",
						country: "US"
					}
				},
				legalCompanyName: "The Merchant",
				customFields: [{
					key: "example-label",
					value: "label-value"
				}],
				includeBeneficiaryAddressInPaymentDetails: !0
			},
			sequenceAccountId: "test-1faa-47ca-9aeb-6205da8f6c47",
			settings: { generateCashCreditGrant: "DISABLED" }
		}
	}
}), Nt = t({
	route: ({ id: e }) => `/credit-notes/${e}/download`,
	queryKey: [fe],
	mocking: {
		match: /\/api\/credit-notes\/(.+)\/download/,
		mock: void 0
	}
}), Pt = t({
	route: (e) => `/credit-notes${i(e)}`,
	queryKey: [te],
	mocking: {
		match: /\/api\/credit-notes(\?(.*))?$/,
		mock: {
			items: [{
				id: "af60cab3-812d-4250-a051-0fb7133a00c7",
				status: "DRAFT",
				invoiceId: "af60cab3-812d-4250-a051-0fb7133a00c7",
				invoiceNumber: "INV00001",
				currency: "GBP",
				issueDate: "2022-09-15",
				billingPeriodStart: "2022-10-01T00:00:00Z",
				billingPeriodEnd: "2022-10-30T00:00:00Z",
				creditNoteNumber: "CN00001",
				purchaseOrderNumber: "PO123",
				customerId: "61b083e0-1faa-47ca-9aeb-6205da8f6c47",
				customerEmails: ["customer@example.com", "customer.alias@example.com"],
				customerLegalCompanyName: "Facebook",
				sequenceAccountId: "test-1faa-47ca-9aeb-6205da8f6c47",
				settings: { generateCashCreditGrant: "DISABLED" },
				customerBillingAddress: {
					line1: "Flat 1",
					line2: "15 Yemen Road",
					town: "Yemen",
					state: "CA",
					postcode: "YE1 2YE",
					country: "US"
				},
				customerShippingAddress: {
					line1: "742 Evergreen Terrace",
					town: "Springfield",
					state: "CA",
					postcode: "12345",
					country: "US"
				},
				memo: "Thanks",
				totalTax: "2.50",
				netTotal: "51.20",
				grossTotal: "101.23",
				metadata: [{
					key: "example-label",
					value: "label-value"
				}],
				linkedServices: [{
					externalId: "123",
					externalService: "Xero",
					syncTime: "2022-06-28T16:47:00Z"
				}],
				merchantDetails: {
					address: {
						line1: "The White House",
						line2: "1600 Pennsylvania Avenue",
						town: "Washington, D.C.",
						state: "CA",
						postcode: "20500",
						country: "US"
					},
					phoneNumber: "0800001066",
					email: "donald@example.com",
					taxId: "TAX60",
					iban: "GB33BUKB20201555555555",
					ukAccountDetails: {
						sortCode: "000000",
						accountNumber: "12345678"
					},
					usAchDetails: {
						accountNumber: "12345678",
						accountName: "John Doe",
						bankName: "Chase",
						bankRoutingNumber: "123456789"
					},
					usWireDetails: {
						accountNumber: "12345678",
						accountName: "John Doe",
						bankName: "Chase",
						bankRoutingNumber: "123456789",
						swiftCode: "CHASUS33",
						bankAddress: {
							line1: "JP Morgan Chase",
							town: "New York City",
							state: "NY",
							postcode: "10017",
							country: "US"
						}
					},
					legalCompanyName: "The Merchant",
					customFields: [{
						key: "example-label",
						value: "label-value"
					}],
					includeBeneficiaryAddressInPaymentDetails: !0
				}
			}],
			pagination: {
				after: "",
				before: "",
				totalResultSize: 1
			}
		}
	}
}), Ft = t({
	route: ({ invoiceId: e }) => `/credit-note-applications/eligibility?invoiceId=${e}`,
	queryKey: [le],
	mocking: {
		match: /\/api\/credit-note-applications\/eligibility(\?(.*))?$/,
		mock: {
			eligible: !0,
			reasons: []
		}
	}
}), It = n({
	route: ({ id: e }) => `/credit-notes/${e}`,
	method: "DELETE",
	invalidateQueries: [g],
	mocking: {
		match: /\/api\/credit-notes\/(.+)$/,
		mock: void 0
	}
}), Lt = n({
	route: () => "/credit-notes",
	method: "POST",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [g],
	mocking: {
		match: /\/api\/credit-notes$/,
		mock: {
			id: "af60cab3-812d-4250-a051-0fb7133a00c7",
			status: "DRAFT",
			invoiceId: "af60cab3-812d-4250-a051-0fb7133a00c7",
			invoiceNumber: "INV00001",
			currency: "GBP",
			issueDate: "2022-09-15",
			accountingDate: "2022-09-15",
			billingPeriodStart: "2022-10-01T00:00:00Z",
			billingPeriodEnd: "2022-10-30T00:00:00Z",
			creditNoteNumber: "CN00001",
			purchaseOrderNumber: "PO123",
			customerId: "61b083e0-1faa-47ca-9aeb-6205da8f6c47",
			customerEmails: ["customer@example.com", "customer.alias@example.com"],
			customerLegalCompanyName: "Facebook",
			customerBillingAddress: {
				line1: "Flat 1",
				line2: "15 Yemen Road",
				town: "Yemen",
				state: "CA",
				postcode: "YE1 2YE",
				country: "US"
			},
			customerShippingAddress: {
				line1: "742 Evergreen Terrace",
				town: "Springfield",
				state: "CA",
				postcode: "12345",
				country: "US"
			},
			memo: "Thanks",
			totalTax: "2.50",
			netTotal: "51.20",
			grossTotal: "101.23",
			metadata: [{
				key: "example-label",
				value: "label-value"
			}],
			linkedServices: [{
				externalId: "123",
				externalService: "Xero",
				syncTime: "2022-06-28T16:47:00Z"
			}],
			merchantDetails: {
				address: {
					line1: "The White House",
					line2: "1600 Pennsylvania Avenue",
					town: "Washington, D.C.",
					state: "CA",
					postcode: "20500",
					country: "US"
				},
				phoneNumber: "0800001066",
				email: "donald@example.com",
				taxId: "TAX60",
				iban: "GB33BUKB20201555555555",
				ukAccountDetails: {
					sortCode: "000000",
					accountNumber: "12345678"
				},
				usAchDetails: {
					accountNumber: "12345678",
					accountName: "John Doe",
					bankName: "Chase",
					bankRoutingNumber: "123456789"
				},
				usWireDetails: {
					accountNumber: "12345678",
					accountName: "John Doe",
					bankName: "Chase",
					bankRoutingNumber: "123456789",
					swiftCode: "CHASUS33",
					bankAddress: {
						line1: "JP Morgan Chase",
						town: "New York City",
						state: "NY",
						postcode: "10017",
						country: "US"
					}
				},
				legalCompanyName: "The Merchant",
				customFields: [{
					key: "example-label",
					value: "label-value"
				}],
				includeBeneficiaryAddressInPaymentDetails: !0
			},
			sequenceAccountId: "test-1faa-47ca-9aeb-6205da8f6c47",
			settings: { generateCashCreditGrant: "DISABLED" }
		}
	}
}), Rt = n({
	route: ({ id: e }) => `/credit-notes/${e}/finalize-and-send`,
	method: "POST",
	invalidateQueries: [g, s],
	mocking: {
		match: /\/api\/credit-notes\/(.+)\/finalize-and-send$/,
		mock: {
			id: "af60cab3-812d-4250-a051-0fb7133a00c7",
			status: "DRAFT",
			invoiceId: "af60cab3-812d-4250-a051-0fb7133a00c7",
			invoiceNumber: "INV00001",
			currency: "GBP",
			issueDate: "2022-09-15",
			accountingDate: "2022-09-15",
			billingPeriodStart: "2022-10-01T00:00:00Z",
			billingPeriodEnd: "2022-10-30T00:00:00Z",
			creditNoteNumber: "CN00001",
			purchaseOrderNumber: "PO123",
			customerId: "61b083e0-1faa-47ca-9aeb-6205da8f6c47",
			customerEmails: ["customer@example.com", "customer.alias@example.com"],
			customerLegalCompanyName: "Facebook",
			customerBillingAddress: {
				line1: "Flat 1",
				line2: "15 Yemen Road",
				town: "Yemen",
				state: "CA",
				postcode: "YE1 2YE",
				country: "US"
			},
			customerShippingAddress: {
				line1: "742 Evergreen Terrace",
				town: "Springfield",
				state: "CA",
				postcode: "12345",
				country: "US"
			},
			memo: "Thanks",
			totalTax: "2.50",
			netTotal: "51.20",
			grossTotal: "101.23",
			metadata: [{
				key: "example-label",
				value: "label-value"
			}],
			linkedServices: [{
				externalId: "123",
				externalService: "Xero",
				syncTime: "2022-06-28T16:47:00Z"
			}],
			merchantDetails: {
				address: {
					line1: "The White House",
					line2: "1600 Pennsylvania Avenue",
					town: "Washington, D.C.",
					state: "CA",
					postcode: "20500",
					country: "US"
				},
				phoneNumber: "0800001066",
				email: "donald@example.com",
				taxId: "TAX60",
				iban: "GB33BUKB20201555555555",
				ukAccountDetails: {
					sortCode: "000000",
					accountNumber: "12345678"
				},
				usAchDetails: {
					accountNumber: "12345678",
					accountName: "John Doe",
					bankName: "Chase",
					bankRoutingNumber: "123456789"
				},
				usWireDetails: {
					accountNumber: "12345678",
					accountName: "John Doe",
					bankName: "Chase",
					bankRoutingNumber: "123456789",
					swiftCode: "CHASUS33",
					bankAddress: {
						line1: "JP Morgan Chase",
						town: "New York City",
						state: "NY",
						postcode: "10017",
						country: "US"
					}
				},
				legalCompanyName: "The Merchant",
				customFields: [{
					key: "example-label",
					value: "label-value"
				}],
				includeBeneficiaryAddressInPaymentDetails: !0
			},
			sequenceAccountId: "test-1faa-47ca-9aeb-6205da8f6c47",
			settings: { generateCashCreditGrant: "DISABLED" }
		}
	}
}), zt = n({
	route: ({ id: e }) => `/credit-notes/${e}/finalize`,
	method: "POST",
	invalidateQueries: [g],
	mocking: {
		match: /\/api\/credit-notes\/(.+)\/finalize$/,
		mock: {
			id: "af60cab3-812d-4250-a051-0fb7133a00c7",
			status: "DRAFT",
			invoiceId: "af60cab3-812d-4250-a051-0fb7133a00c7",
			invoiceNumber: "INV00001",
			currency: "GBP",
			issueDate: "2022-09-15",
			accountingDate: "2022-09-15",
			billingPeriodStart: "2022-10-01T00:00:00Z",
			billingPeriodEnd: "2022-10-30T00:00:00Z",
			creditNoteNumber: "CN00001",
			purchaseOrderNumber: "PO123",
			customerId: "61b083e0-1faa-47ca-9aeb-6205da8f6c47",
			customerEmails: ["customer@example.com", "customer.alias@example.com"],
			customerLegalCompanyName: "Facebook",
			customerBillingAddress: {
				line1: "Flat 1",
				line2: "15 Yemen Road",
				town: "Yemen",
				state: "CA",
				postcode: "YE1 2YE",
				country: "US"
			},
			customerShippingAddress: {
				line1: "742 Evergreen Terrace",
				town: "Springfield",
				state: "CA",
				postcode: "12345",
				country: "US"
			},
			memo: "Thanks",
			totalTax: "2.50",
			netTotal: "51.20",
			grossTotal: "101.23",
			metadata: [{
				key: "example-label",
				value: "label-value"
			}],
			linkedServices: [{
				externalId: "123",
				externalService: "Xero",
				syncTime: "2022-06-28T16:47:00Z"
			}],
			merchantDetails: {
				address: {
					line1: "The White House",
					line2: "1600 Pennsylvania Avenue",
					town: "Washington, D.C.",
					state: "CA",
					postcode: "20500",
					country: "US"
				},
				phoneNumber: "0800001066",
				email: "donald@example.com",
				taxId: "TAX60",
				iban: "GB33BUKB20201555555555",
				ukAccountDetails: {
					sortCode: "000000",
					accountNumber: "12345678"
				},
				usAchDetails: {
					accountNumber: "12345678",
					accountName: "John Doe",
					bankName: "Chase",
					bankRoutingNumber: "123456789"
				},
				usWireDetails: {
					accountNumber: "12345678",
					accountName: "John Doe",
					bankName: "Chase",
					bankRoutingNumber: "123456789",
					swiftCode: "CHASUS33",
					bankAddress: {
						line1: "JP Morgan Chase",
						town: "New York City",
						state: "NY",
						postcode: "10017",
						country: "US"
					}
				},
				legalCompanyName: "The Merchant",
				customFields: [{
					key: "example-label",
					value: "label-value"
				}],
				includeBeneficiaryAddressInPaymentDetails: !0
			},
			sequenceAccountId: "test-1faa-47ca-9aeb-6205da8f6c47",
			settings: { generateCashCreditGrant: "DISABLED" }
		}
	}
}), Bt = n({
	route: ({ id: e }) => `/credit-notes/${e}/send`,
	method: "POST",
	invalidateQueries: [g],
	mocking: {
		match: /\/api\/credit-notes\/(.+)\/send$/,
		mock: {
			id: "af60cab3-812d-4250-a051-0fb7133a00c7",
			status: "DRAFT",
			invoiceId: "af60cab3-812d-4250-a051-0fb7133a00c7",
			invoiceNumber: "INV00001",
			currency: "GBP",
			issueDate: "2022-09-15",
			accountingDate: "2022-09-15",
			billingPeriodStart: "2022-10-01T00:00:00Z",
			billingPeriodEnd: "2022-10-30T00:00:00Z",
			creditNoteNumber: "CN00001",
			purchaseOrderNumber: "PO123",
			customerId: "61b083e0-1faa-47ca-9aeb-6205da8f6c47",
			customerEmails: ["customer@example.com", "customer.alias@example.com"],
			customerLegalCompanyName: "Facebook",
			customerBillingAddress: {
				line1: "Flat 1",
				line2: "15 Yemen Road",
				town: "Yemen",
				state: "CA",
				postcode: "YE1 2YE",
				country: "US"
			},
			customerShippingAddress: {
				line1: "742 Evergreen Terrace",
				town: "Springfield",
				state: "CA",
				postcode: "12345",
				country: "US"
			},
			memo: "Thanks",
			totalTax: "2.50",
			netTotal: "51.20",
			grossTotal: "101.23",
			metadata: [{
				key: "example-label",
				value: "label-value"
			}],
			linkedServices: [{
				externalId: "123",
				externalService: "Xero",
				syncTime: "2022-06-28T16:47:00Z"
			}],
			merchantDetails: {
				address: {
					line1: "The White House",
					line2: "1600 Pennsylvania Avenue",
					town: "Washington, D.C.",
					state: "CA",
					postcode: "20500",
					country: "US"
				},
				phoneNumber: "0800001066",
				email: "donald@example.com",
				taxId: "TAX60",
				iban: "GB33BUKB20201555555555",
				ukAccountDetails: {
					sortCode: "000000",
					accountNumber: "12345678"
				},
				usAchDetails: {
					accountNumber: "12345678",
					accountName: "John Doe",
					bankName: "Chase",
					bankRoutingNumber: "123456789"
				},
				usWireDetails: {
					accountNumber: "12345678",
					accountName: "John Doe",
					bankName: "Chase",
					bankRoutingNumber: "123456789",
					swiftCode: "CHASUS33",
					bankAddress: {
						line1: "JP Morgan Chase",
						town: "New York City",
						state: "NY",
						postcode: "10017",
						country: "US"
					}
				},
				legalCompanyName: "The Merchant",
				customFields: [{
					key: "example-label",
					value: "label-value"
				}],
				includeBeneficiaryAddressInPaymentDetails: !0
			},
			sequenceAccountId: "test-1faa-47ca-9aeb-6205da8f6c47",
			settings: { generateCashCreditGrant: "DISABLED" }
		}
	}
}), Vt = n({
	route: ({ id: e }) => `/credit-notes/${e}/void`,
	method: "POST",
	invalidateQueries: [g],
	mocking: {
		match: /\/api\/credit-notes\/(.+)\/void$/,
		mock: {
			id: "af60cab3-812d-4250-a051-0fb7133a00c7",
			status: "DRAFT",
			invoiceId: "af60cab3-812d-4250-a051-0fb7133a00c7",
			invoiceNumber: "INV00001",
			currency: "GBP",
			issueDate: "2022-09-15",
			accountingDate: "2022-09-15",
			billingPeriodStart: "2022-10-01T00:00:00Z",
			billingPeriodEnd: "2022-10-30T00:00:00Z",
			creditNoteNumber: "CN00001",
			purchaseOrderNumber: "PO123",
			customerId: "61b083e0-1faa-47ca-9aeb-6205da8f6c47",
			customerEmails: ["customer@example.com", "customer.alias@example.com"],
			customerLegalCompanyName: "Facebook",
			customerBillingAddress: {
				line1: "Flat 1",
				line2: "15 Yemen Road",
				town: "Yemen",
				state: "CA",
				postcode: "YE1 2YE",
				country: "US"
			},
			customerShippingAddress: {
				line1: "742 Evergreen Terrace",
				town: "Springfield",
				state: "CA",
				postcode: "12345",
				country: "US"
			},
			memo: "Thanks",
			totalTax: "2.50",
			netTotal: "51.20",
			grossTotal: "101.23",
			metadata: [{
				key: "example-label",
				value: "label-value"
			}],
			linkedServices: [{
				externalId: "123",
				externalService: "Xero",
				syncTime: "2022-06-28T16:47:00Z"
			}],
			merchantDetails: {
				address: {
					line1: "The White House",
					line2: "1600 Pennsylvania Avenue",
					town: "Washington, D.C.",
					state: "CA",
					postcode: "20500",
					country: "US"
				},
				phoneNumber: "0800001066",
				email: "donald@example.com",
				taxId: "TAX60",
				iban: "GB33BUKB20201555555555",
				ukAccountDetails: {
					sortCode: "000000",
					accountNumber: "12345678"
				},
				usAchDetails: {
					accountNumber: "12345678",
					accountName: "John Doe",
					bankName: "Chase",
					bankRoutingNumber: "123456789"
				},
				usWireDetails: {
					accountNumber: "12345678",
					accountName: "John Doe",
					bankName: "Chase",
					bankRoutingNumber: "123456789",
					swiftCode: "CHASUS33",
					bankAddress: {
						line1: "JP Morgan Chase",
						town: "New York City",
						state: "NY",
						postcode: "10017",
						country: "US"
					}
				},
				legalCompanyName: "The Merchant",
				customFields: [{
					key: "example-label",
					value: "label-value"
				}],
				includeBeneficiaryAddressInPaymentDetails: !0
			},
			sequenceAccountId: "test-1faa-47ca-9aeb-6205da8f6c47",
			settings: { generateCashCreditGrant: "DISABLED" }
		}
	}
}), Ht = n({
	route: ({ id: e, testEmail: t }) => `/credit-notes/${e}/send/${t}`,
	method: "POST",
	invalidateQueries: [],
	mocking: {
		match: /\/api\/credit-notes\/(.+)\/send\/(.+)$/,
		mock: {
			id: "af60cab3-812d-4250-a051-0fb7133a00c7",
			status: "DRAFT",
			invoiceId: "af60cab3-812d-4250-a051-0fb7133a00c7",
			invoiceNumber: "INV00001",
			currency: "GBP",
			issueDate: "2022-09-15",
			accountingDate: "2022-09-15",
			billingPeriodStart: "2022-10-01T00:00:00Z",
			billingPeriodEnd: "2022-10-30T00:00:00Z",
			creditNoteNumber: "CN00001",
			purchaseOrderNumber: "PO123",
			customerId: "61b083e0-1faa-47ca-9aeb-6205da8f6c47",
			customerEmails: ["customer@example.com", "customer.alias@example.com"],
			customerLegalCompanyName: "Facebook",
			customerBillingAddress: {
				line1: "Flat 1",
				line2: "15 Yemen Road",
				town: "Yemen",
				state: "CA",
				postcode: "YE1 2YE",
				country: "US"
			},
			customerShippingAddress: {
				line1: "742 Evergreen Terrace",
				town: "Springfield",
				state: "CA",
				postcode: "12345",
				country: "US"
			},
			memo: "Thanks",
			totalTax: "2.50",
			netTotal: "51.20",
			grossTotal: "101.23",
			metadata: [{
				key: "example-label",
				value: "label-value"
			}],
			linkedServices: [{
				externalId: "123",
				externalService: "Xero",
				syncTime: "2022-06-28T16:47:00Z"
			}],
			merchantDetails: {
				address: {
					line1: "The White House",
					line2: "1600 Pennsylvania Avenue",
					town: "Washington, D.C.",
					state: "CA",
					postcode: "20500",
					country: "US"
				},
				phoneNumber: "0800001066",
				email: "donald@example.com",
				taxId: "TAX60",
				iban: "GB33BUKB20201555555555",
				ukAccountDetails: {
					sortCode: "000000",
					accountNumber: "12345678"
				},
				usAchDetails: {
					accountNumber: "12345678",
					accountName: "John Doe",
					bankName: "Chase",
					bankRoutingNumber: "123456789"
				},
				usWireDetails: {
					accountNumber: "12345678",
					accountName: "John Doe",
					bankName: "Chase",
					bankRoutingNumber: "123456789",
					swiftCode: "CHASUS33",
					bankAddress: {
						line1: "JP Morgan Chase",
						town: "New York City",
						state: "NY",
						postcode: "10017",
						country: "US"
					}
				},
				legalCompanyName: "The Merchant",
				customFields: [{
					key: "example-label",
					value: "label-value"
				}],
				includeBeneficiaryAddressInPaymentDetails: !0
			},
			sequenceAccountId: "test-1faa-47ca-9aeb-6205da8f6c47",
			settings: { generateCashCreditGrant: "DISABLED" }
		}
	}
}), z = "entityTypeSyncToggles", B = {
	id: "018f1a2b-3c4d-7e5f-8a9b-0c1d2e3f4a5b",
	integrationService: "Xero",
	entityType: "CUSTOMER",
	syncDirection: "PUSH",
	enabled: !0,
	syncPermission: "ALLOW",
	createdAt: "2026-07-01T09:00:00Z"
}, Ut = {
	id: "018f1a2b-3c4d-7e5f-8a9b-0c1d2e3f4a5b",
	integrationService: "Xero",
	entityType: "CUSTOMER",
	syncDirection: "PUSH",
	enabled: !0,
	createdAt: "2026-07-01T09:00:00Z",
	deletedAt: "2026-07-10T12:00:00Z"
}, Wt = t({
	route: () => "/integrations/settings/entity-type-sync-toggles",
	queryKey: [z],
	mocking: {
		match: /\/api\/integrations\/settings\/entity-type-sync-toggles$/,
		mock: { items: [B] }
	}
}), Gt = n({
	route: () => "/integrations/settings/entity-type-sync-toggles",
	method: "POST",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [z],
	mocking: {
		match: /\/api\/integrations\/settings\/entity-type-sync-toggles$/,
		mock: B
	}
}), Kt = n({
	route: ({ id: e }) => `/integrations/settings/entity-type-sync-toggles/${e}`,
	method: "PUT",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [z],
	mocking: {
		match: /\/api\/integrations\/settings\/entity-type-sync-toggles\/(.+)$/,
		mock: {
			...B,
			enabled: !1,
			syncPermission: "DENY"
		}
	}
}), qt = n({
	route: ({ id: e }) => `/integrations/settings/entity-type-sync-toggles/${e}`,
	method: "DELETE",
	invalidateQueries: [z],
	mocking: {
		match: /\/api\/integrations\/settings\/entity-type-sync-toggles\/(.+)$/,
		mock: Ut
	}
}), Jt = n({
	route: ({ id: e }) => `/credit-notes/${e}/mark-as-sent`,
	method: "POST",
	invalidateQueries: [g],
	mocking: {
		match: /\/credit-notes\/(.+)\/mark-as-sent$/,
		mock: {
			id: "af60cab3-812d-4250-a051-0fb7133a00c7",
			status: "SENT",
			invoiceId: "af60cab3-812d-4250-a051-0fb7133a00c7",
			invoiceNumber: "INV00001",
			billingScheduleId: "fe2fcd0b-4c53-45c7-b2ae-b6c1a7d21e95",
			currency: "GBP",
			issueDate: "2022-09-15",
			billingPeriodStart: "2022-10-01T00:00:00Z",
			billingPeriodEnd: "2022-10-30T00:00:00Z",
			creditNoteNumber: "CN00001",
			purchaseOrderNumber: "PO123",
			customerId: "61b083e0-1faa-47ca-9aeb-6205da8f6c47",
			customerEmails: ["customer@example.com", "customer.alias@example.com"],
			customerLegalCompanyName: "Facebook",
			customerBillingAddress: {
				line1: "Flat 1",
				line2: "15 Yemen Road",
				town: "Yemen",
				state: "CA",
				postcode: "YE1 2YE",
				country: "US"
			},
			customerShippingAddress: {
				line1: "742 Evergreen Terrace",
				town: "Springfield",
				state: "CA",
				postcode: "12345",
				country: "US"
			},
			memo: "Thanks",
			totalTax: "800.00",
			netTotal: "6000.00",
			grossTotal: "6800.00",
			metadata: [{
				key: "example-label",
				value: "label-value"
			}],
			customerTaxId: "TAX123",
			linkedServices: [{
				externalId: "123",
				externalService: "Xero",
				syncTime: "2022-06-28T16:47:00Z"
			}],
			merchantDetails: {
				address: {
					line1: "The White House",
					line2: "1600 Pennsylvania Avenue",
					town: "Washington, D.C.",
					state: "CA",
					postcode: "20500",
					country: "US"
				},
				phoneNumber: "0800001066",
				email: "donald@example.com",
				taxId: "TAX60",
				iban: "GB33BUKB20201555555555",
				ukAccountDetails: {
					sortCode: "000000",
					accountNumber: "12345678"
				},
				usAchDetails: {
					accountNumber: "12345678",
					accountName: "John Doe",
					bankName: "Chase",
					bankRoutingNumber: "123456789"
				},
				usWireDetails: {
					accountNumber: "12345678",
					accountName: "John Doe",
					bankName: "Chase",
					bankRoutingNumber: "123456789",
					swiftCode: "CHASUS33",
					bankAddress: {
						line1: "JP Morgan Chase",
						town: "New York City",
						state: "NY",
						postcode: "10017",
						country: "US"
					}
				},
				legalCompanyName: "The Merchant",
				customFields: [{
					key: "example-label",
					value: "label-value"
				}],
				includeBeneficiaryAddressInPaymentDetails: !0
			},
			sequenceAccountId: "test-1faa-47ca-9aeb-6205da8f6c47",
			settings: { generateCashCreditGrant: "DISABLED" }
		}
	}
}), Yt = n({
	route: () => "/credit-note-applications",
	method: "POST",
	body: ({ body: e }) => JSON.stringify(e),
	headers: () => ({ "Idempotency-Key": crypto.randomUUID() }),
	invalidateQueries: [g, c],
	mocking: {
		match: /\/api\/credit-note-applications$/,
		mock: {
			ledgerTransactionId: "ad4d5e8c-2e9b-4c1e-9b1a-6f1e9c2d7a10",
			creditNoteId: "af60cab3-812d-4250-a051-0fb7133a00c7",
			invoiceId: "61b083e0-1faa-47ca-9aeb-6205da8f6c47",
			amount: 50,
			currency: "USD",
			appliedAt: "2026-06-01T00:00:00Z",
			invoiceBalance: {
				value: 0,
				currency: "USD",
				version: 2
			},
			creditNoteBalance: {
				value: 4150,
				currency: "USD",
				version: 1
			}
		}
	}
}), Xt = n({
	route: ({ id: e }) => `/credit-notes/${e}/recalculate`,
	method: "POST",
	invalidateQueries: [
		g,
		f,
		l,
		s,
		de,
		o,
		b,
		ne
	],
	mocking: {
		match: /\/credit-notes\/(.+)\/recalculate$/,
		mock: {
			id: "af60cab3-812d-4250-a051-0fb7133a00c7",
			status: "DRAFT",
			invoiceId: "af60cab3-812d-4250-a051-0fb7133a00c7",
			invoiceNumber: "INV00001",
			billingScheduleId: "fe2fcd0b-4c53-45c7-b2ae-b6c1a7d21e95",
			currency: "GBP",
			issueDate: "2022-09-15",
			billingPeriodStart: "2022-10-01T00:00:00Z",
			billingPeriodEnd: "2022-10-30T00:00:00Z",
			creditNoteNumber: "CN00001",
			purchaseOrderNumber: "PO123",
			customerId: "61b083e0-1faa-47ca-9aeb-6205da8f6c47",
			customerEmails: ["customer@example.com", "customer.alias@example.com"],
			customerLegalCompanyName: "Facebook",
			customerBillingAddress: {
				line1: "Flat 1",
				line2: "15 Yemen Road",
				town: "Yemen",
				state: "CA",
				postcode: "YE1 2YE",
				country: "US"
			},
			customerShippingAddress: {
				line1: "742 Evergreen Terrace",
				town: "Springfield",
				state: "CA",
				postcode: "12345",
				country: "US"
			},
			memo: "Thanks",
			totalTax: "800.00",
			netTotal: "6000.00",
			grossTotal: "6800.00",
			metadata: [{
				key: "example-label",
				value: "label-value"
			}],
			customerTaxId: "TAX123",
			linkedServices: [],
			merchantDetails: {
				address: {
					line1: "The White House",
					line2: "1600 Pennsylvania Avenue",
					town: "Washington, D.C.",
					state: "CA",
					postcode: "20500",
					country: "US"
				},
				phoneNumber: "0800001066",
				email: "donald@example.com",
				taxId: "TAX60",
				legalCompanyName: "The Merchant",
				customFields: [],
				includeBeneficiaryAddressInPaymentDetails: !0
			},
			sequenceAccountId: "test-1faa-47ca-9aeb-6205da8f6c47",
			settings: { generateCashCreditGrant: "DISABLED" }
		}
	}
}), Zt = n({
	route: ({ id: e }) => `/credit-notes/${e}`,
	method: "PUT",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [g],
	mocking: {
		match: /\/api\/credit-notes\/(.+)$/,
		mock: {
			id: "af60cab3-812d-4250-a051-0fb7133a00c7",
			status: "DRAFT",
			invoiceId: "af60cab3-812d-4250-a051-0fb7133a00c7",
			invoiceNumber: "INV00001",
			billingScheduleId: "fe2fcd0b-4c53-45c7-b2ae-b6c1a7d21e95",
			currency: "GBP",
			issueDate: "2022-09-15",
			accountingDate: "2022-09-15",
			billingPeriodStart: "2022-10-01T00:00:00Z",
			billingPeriodEnd: "2022-10-30T00:00:00Z",
			creditNoteNumber: "CN00001",
			purchaseOrderNumber: "PO123",
			customerId: "61b083e0-1faa-47ca-9aeb-6205da8f6c47",
			customerEmails: ["customer@example.com", "customer.alias@example.com"],
			customerLegalCompanyName: "Facebook",
			customerBillingAddress: {
				line1: "Flat 1",
				line2: "15 Yemen Road",
				town: "Yemen",
				state: "CA",
				postcode: "YE1 2YE",
				country: "US"
			},
			customerShippingAddress: {
				line1: "742 Evergreen Terrace",
				town: "Springfield",
				state: "CA",
				postcode: "12345",
				country: "US"
			},
			memo: "Thanks",
			totalTax: "2.50",
			netTotal: "51.20",
			grossTotal: "101.23",
			metadata: [{
				key: "example-label",
				value: "label-value"
			}],
			customerTaxId: "TAX123",
			linkedServices: [{
				externalId: "123",
				externalService: "Xero",
				syncTime: "2022-06-28T16:47:00Z"
			}],
			merchantDetails: {
				address: {
					line1: "The White House",
					line2: "1600 Pennsylvania Avenue",
					town: "Washington, D.C.",
					state: "CA",
					postcode: "20500",
					country: "US"
				},
				phoneNumber: "0800001066",
				email: "donald@example.com",
				taxId: "TAX60",
				iban: "GB33BUKB20201555555555",
				ukAccountDetails: {
					sortCode: "000000",
					accountNumber: "12345678"
				},
				usAchDetails: {
					accountNumber: "12345678",
					accountName: "John Doe",
					bankName: "Chase",
					bankRoutingNumber: "123456789"
				},
				usWireDetails: {
					accountNumber: "12345678",
					accountName: "John Doe",
					bankName: "Chase",
					bankRoutingNumber: "123456789",
					swiftCode: "CHASUS33",
					bankAddress: {
						line1: "JP Morgan Chase",
						town: "New York City",
						state: "NY",
						postcode: "10017",
						country: "US"
					}
				},
				legalCompanyName: "The Merchant",
				customFields: [{
					key: "example-label",
					value: "label-value"
				}],
				includeBeneficiaryAddressInPaymentDetails: !0
			},
			sequenceAccountId: "test-1faa-47ca-9aeb-6205da8f6c47",
			settings: { generateCashCreditGrant: "DISABLED" }
		}
	}
}), Qt = t({
	route: ({ creditNoteId: e, ...t }) => `/credit-notes/${e}/line-items${i(t)}`,
	queryKey: [f],
	mocking: {
		match: /\/api\/credit-notes\/(.+)\/line-items(\?(.*))?$/,
		mock: {
			items: [{
				id: "af60cab3-812d-4250-a051-0fb7133a00c7",
				creditNoteId: "cd11218d-fa00-4faa-8684-a43113d076a8",
				groupId: "e5bc0f12-4bc1-f821-bc2d-04639a16f9ec",
				lineItemId: "af60cab3-812d-4250-a051-0fb7133a00c7",
				title: "Ferraris",
				description: "Red",
				quantity: "2",
				rate: "2000",
				taxRate: "0.1",
				index: 2,
				priceId: "fe2fcd0b-4c53-45c7-b2ae-b6c1a7d21e95",
				netTotal: "4000",
				totalTax: "400",
				grossTotal: "4400",
				rateDisplay: "ABSOLUTE",
				externalIds: [{
					key: "Xero",
					value: "123"
				}]
			}, {
				id: "bq442312z-812d-4250-a051-0fb7133a00c7",
				creditNoteId: "cd11218d-fa00-4faa-8684-a43113d076a8",
				groupId: "e5bc0f12-4bc1-f821-bc2d-04639a16f9ec",
				lineItemId: "bq442312z-812d-4250-a051-0fb7133a00c7",
				title: "Lambos",
				description: "Green",
				quantity: "1",
				rate: "2000",
				taxRate: "0.2",
				index: 2,
				priceId: "fe2fcd0b-4c53-45c7-b2ae-b6c1a7d21e95",
				netTotal: "2000",
				totalTax: "400",
				grossTotal: "2400",
				rateDisplay: "ABSOLUTE",
				externalIds: [{
					key: "Xero",
					value: "123"
				}],
				servicePeriod: {
					start: "2025-01-01",
					endInclusive: "2025-01-31"
				},
				revenueRecognitionMethod: "STRAIGHT_LINE"
			}],
			pagination: {
				after: "",
				before: "",
				totalResultSize: 2
			}
		}
	}
}), $t = n({
	route: ({ creditNoteId: e }) => `/credit-notes/${e}/line-items`,
	method: "POST",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [
		g,
		l,
		f
	],
	mocking: {
		match: /\/api\/credit-notes\/(.+)\/line-items$/,
		mock: {
			id: "af60cab3-812d-4250-a051-0fb7133a00c7",
			creditNoteId: "af60cab3-812d-4250-a051-0fb7133a00c7",
			groupId: "cd11218d-fa00-4faa-8684-a43113d076a8",
			lineItemId: "af60cab3-812d-4250-a051-0fb7133a00c7",
			title: "Ferraris",
			description: "Red",
			quantity: "2",
			rate: "20000.10",
			taxRate: "0.2",
			index: 2,
			priceId: "fe2fcd0b-4c53-45c7-b2ae-b6c1a7d21e95",
			netTotal: "20000.00",
			totalTax: "2000.00",
			grossTotal: "22000.00",
			rateDisplay: "ABSOLUTE",
			externalIds: [{
				key: "Xero",
				value: "123"
			}],
			servicePeriod: {
				start: "2025-01-01",
				endInclusive: "2025-01-31"
			},
			revenueRecognitionMethod: "POINT_IN_TIME"
		}
	}
}), en = n({
	route: ({ creditNoteId: e, id: t }) => `/credit-notes/${e}/line-items/${t}`,
	method: "PUT",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [
		g,
		l,
		f
	],
	mocking: {
		match: /\/api\/credit-notes\/(.+)\/line-items\/(.+)$/,
		mock: {
			id: "af60cab3-812d-4250-a051-0fb7133a00c7",
			creditNoteId: "af60cab3-812d-4250-a051-0fb7133a00c7",
			groupId: "cd11218d-fa00-4faa-8684-a43113d076a8",
			lineItemId: "af60cab3-812d-4250-a051-0fb7133a00c7",
			title: "Ferraris",
			description: "Red",
			quantity: "2",
			rate: "20000.10",
			taxRate: "0.2",
			index: 2,
			priceId: "fe2fcd0b-4c53-45c7-b2ae-b6c1a7d21e95",
			netTotal: "20000.00",
			totalTax: "2000.00",
			grossTotal: "22000.00",
			rateDisplay: "ABSOLUTE",
			externalIds: [{
				key: "Xero",
				value: "123"
			}]
		}
	}
}), tn = n({
	route: ({ creditNoteId: e, id: t }) => `/credit-notes/${e}/line-items/${t}`,
	method: "DELETE",
	invalidateQueries: [
		g,
		l,
		f
	],
	mocking: {
		match: /\/api\/credit-notes\/(.+)\/line-items\/(.+)$/,
		mock: void 0
	}
}), nn = t({
	route: ({ creditNoteId: e, ...t }) => `/credit-notes/${e}/line-item-groups${i(t)}`,
	queryKey: [l],
	mocking: {
		match: /\/api\/credit-notes\/(.+)\/line-item-groups(\?(.*))?$/,
		mock: {
			items: [{
				id: "e5bc0f12-4bc1-f821-bc2d-04639a16f9ec",
				creditNoteId: "cd11218d-fa00-4faa-8684-a43113d076a8",
				lineItemGroupId: "af60cab3-812d-4250-a051-0fb7133a00c7",
				title: "Users",
				description: "Credit note for users",
				index: 2,
				netTotal: "51.20",
				totalTax: "2.50",
				grossTotal: "101.23"
			}],
			pagination: {
				after: "",
				before: "",
				totalResultSize: 1
			}
		}
	}
}), rn = n({
	route: ({ creditNoteId: e }) => `/credit-notes/${e}/line-item-groups`,
	method: "POST",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [
		g,
		l,
		f
	],
	mocking: {
		match: /\/api\/credit-notes\/(.+)\/line-item-groups$/,
		mock: {
			id: "e5bc0f12-4bc1-f821-bc2d-04639a16f9ec",
			creditNoteId: "af60cab3-812d-4250-a051-0fb7133a00c7",
			lineItemGroupId: "af60cab3-812d-4250-a051-0fb7133a00c7",
			title: "Users",
			description: "Credit note for users",
			index: 2,
			netTotal: "51.20",
			totalTax: "2.50",
			grossTotal: "101.23"
		}
	}
}), an = n({
	route: ({ creditNoteId: e, id: t }) => `/credit-notes/${e}/line-item-groups/${t}`,
	method: "PUT",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [
		g,
		l,
		f
	],
	mocking: {
		match: /\/api\/credit-notes\/(.+)\/line-item-groups\/(.+)$/,
		mock: {
			id: "e5bc0f12-4bc1-f821-bc2d-04639a16f9ec",
			creditNoteId: "af60cab3-812d-4250-a051-0fb7133a00c7",
			lineItemGroupId: "af60cab3-812d-4250-a051-0fb7133a00c7",
			title: "Users",
			description: "Credit note for users",
			index: 2,
			netTotal: "51.20",
			totalTax: "2.50",
			grossTotal: "101.23"
		}
	}
}), on = n({
	route: ({ creditNoteId: e, id: t }) => `/credit-notes/${e}/line-item-groups/${t}`,
	method: "DELETE",
	invalidateQueries: [g, l],
	mocking: {
		match: /\/api\/credit-notes\/(.+)\/line-item-groups\/(.+)$/,
		mock: void 0
	}
}), V = "customers", sn = "customers.labels", H = "customer-custom-property-keys", cn = t({
	route: ({ id: e }) => `/customers/${e}`,
	queryKey: [V],
	persist: !0,
	mocking: {
		match: /\/api\/customers\/(.+)$/,
		mock: {
			id: "test-customer-1",
			status: "ACTIVE",
			createdAt: "2021-01-02T10:55:00Z",
			organizations: [{
				id: "c0dc4e79-ec52-4811-8cf5-addb2527915c",
				owner: {
					id: "50af5191-05a3-42a5-802a-6b59091157af",
					name: "FinTech Solutions Inc."
				},
				members: [{
					id: "e309e948-088e-4d77-b654-cd85498f1555",
					name: "Fintech Payment Processing"
				}, {
					id: "50af5191-05a3-42a5-802a-6b59091157af",
					name: "Fintech Lending Services"
				}]
			}],
			legalName: "Fintech Payment Processing",
			addresses: [{
				purposes: ["BILLING"],
				address: {
					line1: "7500 Bluewater Rd NW",
					town: "Albuquerque",
					state: "NY",
					postcode: "87121",
					country: "US"
				}
			}],
			url: "https://example.com/",
			domain: "example.com",
			label: "Example customer",
			integrationIds: [{
				service: "Xero",
				id: "2aaff66f-ef30-4599-b192-c168fd4cd226",
				lastSynced: "2024-03-28T16:47:00Z",
				isPending: !1
			}, {
				service: "Stripe",
				id: "cus_OCtCxqQDgu1uX9",
				lastSynced: "2024-03-28T16:47:00Z",
				isPending: !1
			}],
			taxStatus: "TAXED",
			contacts: [{
				id: "9a1e38a9-4dc9-776f-f974-4e7ee9f4d6cc",
				name: "John Smith",
				email: "john.smith@example.com",
				purposes: ["BILLING"],
				notificationSubscriptions: ["BILLING"],
				createdAt: "2022-06-28T16:47:00Z",
				updatedAt: "2022-06-28T16:47:00Z",
				archivedAt: "2023-06-28T16:47:00Z"
			}]
		}
	},
	demoModeHandler: (e) => {
		if (e.id === ce.id) return Promise.resolve({
			data: ce,
			error: !1,
			res: new Response()
		});
	}
}), ln = n({
	route: () => "/customers",
	method: "POST",
	body: ({ body: e }) => JSON.stringify({
		...r(e, [
			"name",
			"legalName",
			"email",
			"contactName"
		]),
		contacts: r(e.contacts, ["name", "email"]),
		addresses: r(e.addresses, ["address"])
	}),
	invalidateQueries: [V, H],
	mocking: {
		match: /\/api\/customers$/,
		mock: {
			id: "e309e948-088e-4d77-b654-cd85498f1555",
			status: "ACTIVE",
			createdAt: "2021-01-02T10:55:00Z",
			organizations: [{
				id: "c0dc4e79-ec52-4811-8cf5-addb2527915c",
				owner: {
					id: "50af5191-05a3-42a5-802a-6b59091157af",
					name: "FinTech Solutions Inc."
				},
				members: [{
					id: "e309e948-088e-4d77-b654-cd85498f1555",
					name: "Fintech Payment Processing"
				}, {
					id: "50af5191-05a3-42a5-802a-6b59091157af",
					name: "Fintech Lending Services"
				}]
			}],
			legalName: "Fintech Payment Processing",
			addresses: [{
				purposes: ["BILLING"],
				address: {
					line1: "7500 Bluewater Rd NW",
					town: "Albuquerque",
					state: "NY",
					postcode: "87121",
					country: "US"
				}
			}],
			url: "https://example.com/",
			domain: "example.com",
			label: "Example customer",
			integrationIds: [{
				service: "Xero",
				id: "2aaff66f-ef30-4599-b192-c168fd4cd226",
				lastSynced: "2024-03-28T16:47:00Z",
				isPending: !1
			}, {
				service: "Stripe",
				id: "cus_OCtCxqQDgu1uX9",
				lastSynced: "2024-03-28T16:47:00Z",
				isPending: !1
			}],
			taxStatus: "TAXED",
			contacts: [{
				id: "9a1e38a9-4dc9-776f-f974-4e7ee9f4d6cc",
				name: "John Smith",
				email: "john.smith@example.com",
				purposes: [],
				notificationSubscriptions: [],
				createdAt: "2022-06-28T16:47:00Z",
				updatedAt: "2022-06-28T16:47:00Z",
				archivedAt: "2023-06-28T16:47:00Z"
			}]
		}
	}
}), un = n({
	route: ({ id: e }) => `/customers/${e}`,
	method: "PUT",
	body: ({ body: e }) => {
		let { address: t, ...n } = e;
		return JSON.stringify({
			...r(n, ["legalName"]),
			contacts: r(n.contacts, ["name", "email"]),
			addresses: r(n.addresses, ["address"])
		});
	},
	invalidateQueries: [
		V,
		H,
		se
	],
	mocking: {
		match: /\/api\/customers\/(.+)$/,
		mock: {
			id: "e309e948-088e-4d77-b654-cd85498f1555",
			status: "ACTIVE",
			createdAt: "2021-01-02T10:55:00Z",
			organizations: [{
				id: "c0dc4e79-ec52-4811-8cf5-addb2527915c",
				owner: {
					id: "50af5191-05a3-42a5-802a-6b59091157af",
					name: "FinTech Solutions Inc."
				},
				members: [{
					id: "e309e948-088e-4d77-b654-cd85498f1555",
					name: "Fintech Payment Processing"
				}, {
					id: "50af5191-05a3-42a5-802a-6b59091157af",
					name: "Fintech Lending Services"
				}]
			}],
			legalName: "Fintech Payment Processing",
			addresses: [{
				purposes: ["BILLING"],
				address: {
					line1: "7500 Bluewater Rd NW",
					town: "Albuquerque",
					state: "NY",
					postcode: "87121",
					country: "US"
				}
			}],
			url: "https://example.com/",
			domain: "example.com",
			label: "Example customer",
			integrationIds: [{
				service: "Xero",
				id: "2aaff66f-ef30-4599-b192-c168fd4cd226",
				lastSynced: "2024-03-28T16:47:00Z",
				isPending: !1
			}, {
				service: "Stripe",
				id: "cus_OCtCxqQDgu1uX9",
				lastSynced: "2024-03-28T16:47:00Z",
				isPending: !1
			}],
			taxStatus: "TAXED",
			contacts: [{
				id: "9a1e38a9-4dc9-776f-f974-4e7ee9f4d6cc",
				name: "John Smith",
				email: "john.smith@example.com",
				purposes: [],
				notificationSubscriptions: [],
				createdAt: "2022-06-28T16:47:00Z",
				updatedAt: "2022-06-28T16:47:00Z",
				archivedAt: "2023-06-28T16:47:00Z"
			}]
		}
	}
}), dn = t({
	route: (e) => `/customers${i(e)}`,
	queryKey: [V],
	persist: !0,
	mocking: {
		match: /\/api\/customers(\?(.*))?$/,
		mock: {
			items: [{
				id: "test-customer-1",
				createdAt: "2021-01-02T10:55:00Z",
				organizations: [{
					id: "c0dc4e79-ec52-4811-8cf5-addb2527915c",
					owner: {
						id: "50af5191-05a3-42a5-802a-6b59091157af",
						name: "FinTech Solutions Inc."
					},
					members: [{
						id: "test-customer-1",
						name: "Fintech Payment Processing"
					}, {
						id: "50af5191-05a3-42a5-802a-6b59091157af",
						name: "Fintech Lending Services"
					}]
				}],
				legalName: "Fintech Payment Processing",
				addresses: [{
					purposes: ["BILLING"],
					address: {
						line1: "7500 Bluewater Rd NW",
						town: "Albuquerque",
						state: "NY",
						postcode: "87121",
						country: "US"
					}
				}],
				url: "https://example.com/",
				domain: "example.com",
				label: "Example customer",
				integrationIds: [{
					service: "Xero",
					id: "2aaff66f-ef30-4599-b192-c168fd4cd226",
					lastSynced: "2024-03-28T16:47:00Z",
					isPending: !1
				}, {
					service: "Stripe",
					id: "cus_OCtCxqQDgu1uX9",
					lastSynced: "2024-03-28T16:47:00Z",
					isPending: !1
				}],
				taxStatus: "TAXED"
			}],
			pagination: {
				after: "",
				before: "",
				totalResultSize: 1
			}
		}
	}
}), fn = t({
	route: (e) => `/customers/labels${i(e)}`,
	queryKey: [V, sn],
	mocking: {
		match: /\/api\/customers\/labels(\?(.*))?$/,
		mock: {
			items: ["Enterprise", "SMB"],
			pagination: { totalResultSize: 2 }
		}
	}
}), pn = n({
	route: () => "/revenue/journals",
	body: (e) => JSON.stringify(e),
	method: "POST",
	invalidateQueries: [
		T,
		D,
		E
	],
	mocking: {
		match: /\/api\/revenue\/journals$/,
		mock: {
			id: "3f9a90d2-37fd-41c7-11fa-3d5f82bb9bea",
			journalType: "MANUAL",
			ledgerId: "ec30d4ba-213d-4435-abf7-fe829b7ecb03",
			narrative: "Journal narrative",
			date: "2021-01-01",
			entries: [{
				id: "3d1bcf09-409a-495d-959b-12eebfc20e0d",
				journalId: "3f9a90d2-37fd-41c7-11fa-3d5f82bb9bea",
				account: {
					id: "a8639230-5594-4f10-bc56-70edbb6c9e08",
					name: "RECOGNIZED_REVENUE"
				},
				direction: "DEBIT",
				amount: 100
			}, {
				id: "3d1bcf09-409a-495d-959b-12eebfc20e0d",
				journalId: "3f9a90d2-37fd-41c7-11fa-3d5f82bb9bea",
				account: {
					id: "a8639230-5594-4f10-bc56-70edbb6c9e08",
					name: "RECOGNIZED_REVENUE"
				},
				direction: "CREDIT",
				amount: 100
			}],
			createdAt: "2021-01-01T00:00:00Z"
		}
	}
}), U = "stripeCollectionsSettings", mn = t({
	route: () => "/stripe/collections/settings",
	queryKey: [U],
	mocking: {
		match: /\/api\/stripe\/collections\/settings$/,
		mock: {
			id: "exampleId",
			sequenceAccountId: "exampleSequenceAccountId",
			enableAutomaticPayments: !0,
			autoEnableStripePayments: !1,
			retryOffsetDays: []
		}
	}
}), hn = n({
	route: ({ id: e }) => `/stripe/collections/settings/${e}`,
	method: "PUT",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [U],
	mocking: {
		match: /\/api\/stripe\/collections\/settings\/(.+)$/,
		mock: {
			enableAutomaticPayments: !0,
			autoEnableStripePayments: !1,
			retryOffsetDays: [],
			id: "3e120085-52e8-457b-a23c-31c0f135e809",
			sequenceAccountId: "exampleSequenceAccountId"
		}
	}
}), W = "goCardlessCollectionsMandate", gn = {
	getGoCardlessCollectionsMandate: t({
		route: (e) => `/gocardless/collections/mandate${i(e)}`,
		queryKey: [W],
		mocking: {
			match: /\/api\/gocardless\/collections\/mandate(\?(.*))?$/,
			mock: { mandates: [{
				id: "019d484c-c9af-748f-ae9d-da91ae944b69",
				externalMandateId: "MD01KN44NQP2M5EET59ME2VTTG63",
				status: "PENDING_SUBMISSION",
				createdAt: "2026-04-01T09:08:05.167317Z"
			}] }
		}
	}),
	postCancelGoCardlessCollectionsMandate: n({
		route: ({ mandateId: e }) => `/gocardless/collections/mandate/${e}/cancel`,
		method: "POST",
		invalidateQueries: [W],
		mocking: {
			match: /\/api\/gocardless\/collections\/mandate\/(.+)\/cancel$/,
			mock: {
				id: "af60cab3-812d-4250-a051-0fb7133a00c7",
				externalMandateId: "MD0001",
				status: "CANCELLED",
				createdAt: "2024-01-15T10:30:00Z"
			}
		}
	})
}, G = "billingSchedules", _n = "billingSchedulesCsvDownload", vn = n({
	route: ({ service: e, billingScheduleId: t }) => `/integrations/${e}/sync-billing-schedule/${t}`,
	method: "POST",
	invalidateQueries: [G],
	mocking: {
		match: /\/api\/integrations\/(.+)\/sync-billing-schedule\/(.+)$/,
		mock: void 0
	}
}), yn = t({
	route: ({ id: e }) => `/billing-schedules/${e}`,
	queryKey: [G],
	mocking: {
		match: /\/api\/billing-schedules\/(.+)/,
		mock: {
			startDate: "2022-01-01",
			endDate: "2022-01-31",
			taxRates: [{
				priceId: "test-price",
				taxRateId: "test-tax-rate"
			}],
			id: "schedule-1",
			customerId: "customer-1",
			status: "COMPLETED",
			phases: [{
				id: "test-phase",
				priceIds: ["test-price"],
				startDate: "2022-01-01",
				endDate: "2022-01-31",
				name: "A phase name",
				discounts: [{
					id: "discount-1",
					restrictToPrices: ["test-price"],
					type: "PERCENTAGE",
					amount: 10,
					message: "test-message",
					seatDiscountType: "ALL_SEATS"
				}],
				minimums: [{
					id: "minimum-1",
					restrictToPrices: ["test-price"],
					amount: 10
				}],
				integrationIds: [],
				recurrencePreference: "CONTINUE_FROM_PREVIOUS_PHASE"
			}],
			prices: [],
			integrationIds: [],
			autoIssueInvoices: !1,
			purchaseOrderNumber: "test-purchase-order",
			reference: "test-reference",
			label: "test-label",
			recurrenceDayOfMonth: 1,
			rollUpBilling: !1,
			createdAt: "2024-06-17T17:00:00.000Z",
			attachmentAssets: [{
				id: "test-asset-id",
				type: "IMAGE",
				format: "PDF",
				fileName: "my-image.png",
				fileSizeBytes: 12345,
				url: "https://assets.sequencehq.com/123/images/test-asset-id.png",
				createdBy: "upload-user-1",
				createdAt: "2025-03-11T00:00:00.000Z"
			}],
			contractId: "0194d091-f65b-7b98-b75f-a923aa0f5b1a"
		}
	}
}), bn = "quickbooksAccounts", xn = "quickbooksTaxCodes", K = "defaultQuickbooksTaxCodes", q = "defaultQuickbooksAccount", J = "quickbooksTaxCodeMappings", Sn = t({
	route: () => "/quickbooks/accounts",
	queryKey: [bn],
	mocking: {
		match: /\/api\/quickbooks\/accounts$/,
		mock: {
			items: [{
				id: "f28868b3-7288-4851-9f87-967f37d2c874",
				type: "INCOME",
				subType: "SALES_OF_PRODUCT_INCOME",
				classification: "Asset",
				name: "Account Name",
				description: "Account Description"
			}],
			pagination: {
				after: "",
				before: "",
				totalResultSize: 1
			}
		}
	}
}), Cn = n({
	route: ({ productId: e }) => `/quickbooks/push-product/${e}`,
	method: "POST",
	invalidateQueries: [S],
	body: ({ accountId: e }) => JSON.stringify({ accountId: e }),
	mocking: {
		match: /api\/quickbooks\/push-product\/[^\/]+$/,
		mock: {
			quickbooksItemId: "93fb094f-b02d-4612-8dc0-110a5e8c90cc",
			quickbooksItemName: "SaaS API access",
			quickbooksAccountId: "420bf378-afb7-4ca8-864f-02fc51413274",
			quickbooksAccountName: "Online Products Inc."
		}
	}
}), wn = t({
	route: () => "/quickbooks/tax-codes",
	queryKey: [xn],
	mocking: {
		match: /\/api\/quickbooks\/tax-codes$/,
		mock: {
			items: [
				{
					id: "1010",
					name: "20.0% RC",
					description: "Reverse Charge"
				},
				{
					id: "1020",
					name: "Exempt",
					description: "Exempt From VAT"
				},
				{
					id: "1030",
					name: "20.0% S",
					description: "Standard Rate"
				},
				{
					id: "1040",
					name: "5.0% R",
					description: "Reduced Rate"
				},
				{
					id: "1050",
					name: "0.0% Z",
					description: "Zero Rate"
				}
			],
			pagination: {
				after: "",
				before: "",
				totalResultSize: 1
			}
		}
	}
}), Tn = t({
	route: () => "/quickbooks/tax-codes/defaults",
	queryKey: [K],
	mocking: {
		match: /\/api\/quickbooks\/tax-codes\/defaults$/,
		mock: {
			taxable: {
				id: "1030",
				name: "20.0% S",
				description: "Standard Rate"
			},
			exempt: {
				id: "1020",
				name: "Exempt",
				description: "Exempt From VAT"
			},
			reverseCharged: {
				id: "1010",
				name: "20.0% RC",
				description: "Reverse Charge"
			}
		}
	}
}), En = n({
	route: () => "/quickbooks/tax-codes/defaults",
	method: "PUT",
	body: (e) => JSON.stringify(e),
	invalidateQueries: [K],
	mocking: {
		match: /\/api\/quickbooks\/tax-codes\/defaults$/,
		mock: {
			taxable: {
				id: "1030",
				name: "20.0% S",
				description: "Standard Rate"
			},
			exempt: {
				id: "1020",
				name: "Exempt",
				description: "Exempt From VAT"
			},
			reverseCharged: {
				id: "1010",
				name: "20.0% RC",
				description: "Reverse Charge"
			}
		}
	}
}), Dn = t({
	route: () => "/quickbooks/accounts/defaults",
	queryKey: [q],
	mocking: {
		match: /\/api\/quickbooks\/accounts\/defaults$/,
		mock: { standard: {
			id: "f28868b3-7288-4851-9f87-967f37d2c874",
			type: "Bank",
			subType: "Checking",
			classification: "Asset",
			name: "Account Name",
			description: "Account Description"
		} }
	}
}), On = n({
	route: () => "/quickbooks/accounts/defaults",
	method: "PUT",
	body: (e) => JSON.stringify(e),
	invalidateQueries: [q],
	mocking: {
		match: /\/api\/quickbooks\/accounts\/defaults$/,
		mock: { standard: {
			id: "f28868b3-7288-4851-9f87-967f37d2c874",
			type: "Bank",
			subType: "Checking",
			classification: "Asset",
			name: "Account Name",
			description: "Account Description"
		} }
	}
}), kn = t({
	route: () => "/quickbooks/tax-codes/associations",
	queryKey: [J],
	mocking: {
		match: /\/api\/quickbooks\/tax-codes\/associations$/,
		mock: { items: [{
			taxCategoryId: "f70e5a2a-2c75-48fe-bd6d-b55ed59c194e",
			taxCategoryName: "VAT",
			taxCodeId: "1",
			taxCodeName: "VAT"
		}] }
	}
}), An = n({
	route: () => "/quickbooks/tax-codes/associations",
	method: "POST",
	body: (e) => JSON.stringify(e),
	invalidateQueries: [J],
	mocking: {
		match: /\/api\/quickbooks\/tax-codes\/associations$/,
		mock: {
			taxCategoryId: "f70e5a2a-2c75-48fe-bd6d-b55ed59c194e",
			taxCodeId: "taxCodeId"
		}
	}
}), jn = t({
	route: (e) => `/revenue/journals/paginated${i(e)}`,
	queryKey: [T],
	mocking: {
		match: /\/api\/revenue\/journals\/paginated(\?(.*))?$/,
		mock: {
			pagination: {
				after: "1",
				before: "2"
			},
			items: [{
				id: "3f9a90d2-37fd-41c7-11fa-3d5f82bb9bea",
				journalType: "SYSTEM",
				ledgerId: "ec30d4ba-213d-4435-abf7-fe829b7ecb03",
				narrative: "Journal narrative",
				date: "2021-01-01",
				product: {
					id: "3f9a90d2-37fd-41c7-11fa-3d5f82bb9bea",
					name: "Platform Access"
				},
				customer: {
					id: "3f9a90d2-37fd-41c7-11fa-3d5f82bb9bea",
					name: "ACME Inc."
				},
				invoice: {
					id: "9724073f-675b-434a-9004-2119a9541c3c",
					name: "INV-003"
				},
				entries: [{
					id: "3d1bcf09-409a-495d-959b-12eebfc20e0d",
					journalId: "3f9a90d2-37fd-41c7-11fa-3d5f82bb9bea",
					account: {
						id: "a8639230-5594-4f10-bc56-70edbb6c9e08",
						name: "DEFERRED_REVENUE"
					},
					direction: "DEBIT",
					amount: 100
				}, {
					id: "3d1bcf09-409a-495d-959b-12eebfc20e0d",
					journalId: "3f9a90d2-37fd-41c7-11fa-3d5f82bb9bea",
					account: {
						id: "a8639230-5594-4f10-bc56-70edbb6c9e08",
						name: "RECOGNIZED_REVENUE"
					},
					direction: "CREDIT",
					amount: 100
				}],
				createdAt: "2021-01-01T00:00:00Z"
			}]
		}
	}
}), Mn = t({
	route: (e) => `/revenue/overview${i({
		currency: e.currency,
		startDate: e.startDate,
		endDate: e.endDate,
		customerIds: e.customerIds?.join(","),
		productIds: e.productIds?.join(",")
	})}`,
	queryKey: [Oe],
	mocking: {
		match: /\/api\/revenue\/overview(\?(.*))?$/,
		mock: {
			summary: {
				totalRecognized: 12038874,
				totalDeferred: 38874,
				manualInterventionRate: 12.5,
				startDate: "2024-06-01",
				endDate: "2025-05-30"
			},
			monthlyRevenue: {
				data: [
					{
						year: 2023,
						month: 2,
						recognizedAmount: 15e5,
						percentage: 12.5,
						isHighest: !1,
						isLowest: !1
					},
					{
						year: 2023,
						month: 3,
						recognizedAmount: 18e5,
						percentage: 15,
						isHighest: !1,
						isLowest: !1
					},
					{
						year: 2023,
						month: 4,
						recognizedAmount: 12e5,
						percentage: 10,
						isHighest: !1,
						isLowest: !0
					},
					{
						year: 2023,
						month: 5,
						recognizedAmount: 22e5,
						percentage: 18.3,
						isHighest: !1,
						isLowest: !1
					},
					{
						year: 2023,
						month: 6,
						recognizedAmount: 19e5,
						percentage: 15.8,
						isHighest: !1,
						isLowest: !1
					},
					{
						year: 2023,
						month: 7,
						recognizedAmount: 8e5,
						percentage: 6.7,
						isHighest: !1,
						isLowest: !1
					},
					{
						year: 2023,
						month: 8,
						recognizedAmount: 16e5,
						percentage: 13.3,
						isHighest: !1,
						isLowest: !1
					},
					{
						year: 2023,
						month: 9,
						recognizedAmount: 14e5,
						percentage: 11.7,
						isHighest: !1,
						isLowest: !1
					},
					{
						year: 2023,
						month: 10,
						recognizedAmount: 28e5,
						percentage: 23.3,
						isHighest: !0,
						isLowest: !1
					},
					{
						year: 2023,
						month: 11,
						recognizedAmount: 17e5,
						percentage: 14.2,
						isHighest: !1,
						isLowest: !1
					},
					{
						year: 2024,
						month: 0,
						recognizedAmount: 15e5,
						percentage: 12.5,
						isHighest: !1,
						isLowest: !1
					},
					{
						year: 2024,
						month: 1,
						recognizedAmount: 21e5,
						percentage: 17.5,
						isHighest: !1,
						isLowest: !1
					}
				],
				totalRevenue: 12038874,
				highestMonth: {
					year: 2023,
					month: 10,
					recognizedAmount: 28e5,
					percentage: 23.3,
					isHighest: !0,
					isLowest: !1
				},
				lowestMonth: {
					year: 2023,
					month: 4,
					recognizedAmount: 12e5,
					percentage: 10,
					isHighest: !1,
					isLowest: !0
				},
				percentageDifference: 13.3
			},
			monthlyDeferrals: {
				data: [
					{
						year: 2023,
						month: 2,
						deferredAmount: 15e5,
						percentage: 12.5,
						isHighest: !1,
						isLowest: !1
					},
					{
						year: 2023,
						month: 3,
						deferredAmount: 18e5,
						percentage: 15,
						isHighest: !1,
						isLowest: !1
					},
					{
						year: 2023,
						month: 4,
						deferredAmount: 12e5,
						percentage: 10,
						isHighest: !1,
						isLowest: !0
					},
					{
						year: 2023,
						month: 5,
						deferredAmount: 22e5,
						percentage: 18.3,
						isHighest: !1,
						isLowest: !1
					},
					{
						year: 2023,
						month: 6,
						deferredAmount: 19e5,
						percentage: 15.8,
						isHighest: !1,
						isLowest: !1
					},
					{
						year: 2023,
						month: 7,
						deferredAmount: 8e5,
						percentage: 6.7,
						isHighest: !1,
						isLowest: !1
					},
					{
						year: 2023,
						month: 8,
						deferredAmount: 16e5,
						percentage: 13.3,
						isHighest: !1,
						isLowest: !1
					},
					{
						year: 2023,
						month: 9,
						deferredAmount: 14e5,
						percentage: 11.7,
						isHighest: !1,
						isLowest: !1
					},
					{
						year: 2023,
						month: 10,
						deferredAmount: 28e5,
						percentage: 23.3,
						isHighest: !0,
						isLowest: !1
					},
					{
						year: 2023,
						month: 11,
						deferredAmount: 17e5,
						percentage: 14.2,
						isHighest: !1,
						isLowest: !1
					},
					{
						year: 2024,
						month: 0,
						deferredAmount: 15e5,
						percentage: 12.5,
						isHighest: !1,
						isLowest: !1
					},
					{
						year: 2024,
						month: 1,
						deferredAmount: 21e5,
						percentage: 17.5,
						isHighest: !1,
						isLowest: !1
					}
				],
				highestMonth: {
					year: 2023,
					month: 10,
					deferredAmount: 28e5,
					percentage: 23.3,
					isHighest: !0,
					isLowest: !1
				},
				lowestMonth: {
					year: 2023,
					month: 4,
					deferredAmount: 12e5,
					percentage: 10,
					isHighest: !1,
					isLowest: !0
				},
				percentageDifference: 13.3
			},
			topCustomers: {
				customers: [
					{
						customerId: "customer_vercel",
						customerLegalName: "Vercel Inc",
						recognizedRevenue: 9631610,
						deferredRevenue: 0,
						totalRevenue: 9631610,
						percentageOfTotal: 48,
						rank: 1
					},
					{
						customerId: "customer_loom",
						customerLegalName: "Loom Inc",
						recognizedRevenue: 1231610,
						deferredRevenue: 0,
						totalRevenue: 1231610,
						percentageOfTotal: 23,
						rank: 2
					},
					{
						customerId: "customer_docusign",
						customerLegalName: "DocuSign Ltd",
						recognizedRevenue: 810208,
						deferredRevenue: 0,
						totalRevenue: 810208,
						percentageOfTotal: 16,
						rank: 3
					},
					{
						customerId: "customer_atlassian",
						customerLegalName: "Atlassian Inc",
						recognizedRevenue: 432e3,
						deferredRevenue: 0,
						totalRevenue: 432e3,
						percentageOfTotal: 8,
						rank: 4
					},
					{
						customerId: "customer_unsplash",
						customerLegalName: "Unsplash Limited",
						recognizedRevenue: 46e3,
						deferredRevenue: 0,
						totalRevenue: 46e3,
						percentageOfTotal: 2,
						rank: 5
					}
				],
				totalRevenue: 12038874,
				concentrationRisk: {
					level: "MEDIUM",
					score: 45.5
				}
			}
		}
	}
}), Nn = t({
	route: (e) => `/revenue/deferred-revenue-schedules/paginated${i(e)}`,
	queryKey: [D],
	mocking: {
		match: /\/api\/revenue\/deferred-revenue-schedules\/paginated(\?(.*))?$/,
		mock: {
			pagination: {
				after: "M2Y5YTkwZDItMzdmZC00MWM3LTExZmEtM2Q1ZjgyYmI5YmVh",
				before: "M2Y5YTkwZDItMzdmZC00MWM3LTExZmEtM2Q1ZjgyYmI5YmVh",
				totalResultSize: 6
			},
			items: [
				{
					id: "c2e09017-27b4-4364-b36a-f658ae893156",
					recognitionMethod: "STRAIGHT_LINE",
					customer: {
						id: "9b76ad36-e9a7-4a6c-b62a-d7cce18dcc2f",
						name: "Google Ltd",
						domain: "google.com"
					},
					product: {
						id: "ce2dd8cd-e113-4877-93a7-1a0355f1d1ce",
						name: "Platform fee"
					},
					invoice: {
						id: "49ccecf1-2035-4a1e-8d0c-fdc676da6211",
						name: "INV0001"
					},
					progress: {
						currency: "GBP",
						original: "128.00",
						recognized: "28.00",
						remaining: "100.00"
					}
				},
				{
					id: "5ef311e8-157a-48b9-887c-c2c4d36aef97",
					recognitionMethod: "STRAIGHT_LINE",
					customer: {
						id: "b2b77c6c-e393-4429-af9b-e22c7e324b22",
						name: "DocuSign Ltd",
						domain: "docusign.com"
					},
					product: {
						id: "8133aab8-9660-438a-b5d2-6e3b1bdb7c41",
						name: "Platform fee"
					},
					invoice: {
						id: "26413014-25fc-4075-8b17-9958cde004a5",
						name: "INV00002"
					},
					progress: {
						currency: "GBP",
						original: "1600.00",
						recognized: "700.00",
						remaining: "900.00"
					}
				},
				{
					id: "40c4b1cf-77e4-4cf7-9903-42901c24834e",
					recognitionMethod: "STRAIGHT_LINE",
					customer: {
						id: "f5812db7-9eac-4c33-aee2-7206a9f73d2d",
						name: "Brex",
						domain: "brex.com"
					},
					product: {
						id: "768d2850-72a8-417e-b646-1da0f454a4c8",
						name: "Platform fee"
					},
					invoice: {
						id: "fa1e72fa-e307-4901-88b9-86e682c3b3bd",
						name: "INV00003"
					},
					progress: {
						currency: "GBP",
						original: "364.00",
						recognized: "229.00",
						remaining: "135.00"
					}
				},
				{
					id: "a58b4309-7882-482b-adb6-ce91021c5dcc",
					recognitionMethod: "STRAIGHT_LINE",
					customer: {
						id: "0aeced5b-2963-4326-b8d9-bb946e68c5f8",
						name: "Intercom BV",
						domain: "intercom.com"
					},
					product: {
						id: "6dd60603-27ec-4ea0-96b3-66370e109c28",
						name: "Platform fee"
					},
					invoice: {
						id: "ad8e8b86-a5f0-4def-bab3-50cab155de30",
						name: "INV00004"
					},
					progress: {
						currency: "GBP",
						original: "196.00",
						recognized: "96.00",
						remaining: "100.00"
					}
				},
				{
					id: "9e83399a-ce8a-4fc4-bd7a-7cd3d0a4ef21",
					recognitionMethod: "USAGE",
					customer: {
						id: "da3bc6c9-af43-47d7-8f63-246dee7e0670",
						name: "Loom Inc",
						domain: "loom.com"
					},
					product: {
						id: "444f5f67-fa94-4b2b-a9f3-5ff06b5ae849",
						name: "API Access"
					},
					invoice: {
						id: "ac36b97e-19c2-45d1-b46a-a0f0dbfb59f9",
						name: "INV00002"
					},
					progress: {
						currency: "GBP",
						original: "2400.00",
						recognized: "1200.00",
						remaining: "1200.00"
					}
				},
				{
					id: "f9320cd6-2fa8-4b72-9c3f-398597336161",
					recognitionMethod: "MILESTONE",
					customer: {
						id: "f1de1a73-5762-43db-850b-b361a9ba1bc7",
						name: "Mayo Clinic",
						domain: "mayoclinic.com"
					},
					product: {
						id: "3e62de86-80bc-4a91-a3f3-569f6ff9f384",
						name: "Professional Services"
					},
					invoice: {
						id: "afc2045c-509b-46f0-bcfd-976468c3f9d0",
						name: "INV00007"
					},
					progress: {
						currency: "GBP",
						original: "5000.00",
						recognized: "0.00",
						remaining: "5000.00"
					}
				}
			]
		}
	}
}), Pn = t({
	route: (e) => `/revenue/waterfall-table-data${i(e)}`,
	queryKey: [ke],
	mocking: {
		match: /\/api\/revenue\/waterfall-table-data(\?(.*))?$/,
		mock: {
			items: [{
				id: "0198c7cf-16b7-758c-90e9-5d84fe2ece72",
				label: "Acme Corporation",
				groupType: "CUSTOMER",
				bookedTotal: 1e4,
				recognized: 7500,
				remaining: 2500,
				monthlyColumns: {},
				children: [{
					id: "0198c8fa-736a-753b-ae9c-9ac6e5890a16",
					label: "Premium Plan",
					groupType: "PRODUCT",
					bookedTotal: 6e3,
					recognized: 4500,
					remaining: 1500,
					monthlyColumns: {},
					children: []
				}]
			}],
			totals: {
				bookedTotal: 1e4,
				recognized: 7500,
				remaining: 2500,
				monthlyColumns: {}
			},
			pagination: {
				after: "M2Y5YTkwZDItMzdmZC00MWM3LTExZmEtM2Q1ZjgyYmI5YmVh",
				before: "M2Y5YTkwZDItMzdmZC00MWM3LTExZmEtM2Q1ZjgyYmI5YmVh",
				totalResultSize: 1
			}
		}
	}
}), Fn = n({
	route: () => "/revenue/waterfall-reports",
	body: (e) => JSON.stringify(e),
	method: "POST",
	invalidateQueries: [O],
	mocking: {
		match: /\/api\/revenue\/waterfall-reports$/,
		mock: void 0,
		status: 202
	}
}), In = t({
	route: ({ signature: e }) => `/revenue/waterfall-reports/signed-download?signature=${encodeURIComponent(e)}`,
	queryKey: [O],
	mocking: {
		match: /\/api\/revenue\/waterfall-reports\/signed-download\?signature=/,
		mock: { url: "https://cdn.example.com/revenue-waterfall.csv" }
	}
}), Y = "xeroLedgerAccountMappings", Ln = t({
	route: () => "/revenue/xero/ledger-account-mappings",
	queryKey: [Y],
	mocking: {
		match: /\/api\/revenue\/xero\/ledger-account-mappings$/,
		mock: { items: [] }
	}
}), Rn = n({
	route: () => "/revenue/xero/ledger-account-mappings",
	method: "POST",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [Y],
	mocking: {
		match: /\/api\/revenue\/xero\/ledger-account-mappings$/,
		mock: {
			id: "550e8400-e29b-41d4-a716-446655440000",
			mappableLedgerAccount: "DEFERRED_REVENUE",
			xeroLedgerAccountCode: "200",
			xeroLedgerAccountName: "Deferred Revenue",
			isDefault: !0,
			createdAt: "2026-04-13T10:00:00Z",
			updatedAt: "2026-04-13T10:00:00Z"
		}
	}
}), zn = n({
	route: ({ id: e }) => `/revenue/xero/ledger-account-mappings/${e}`,
	method: "PUT",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [Y],
	mocking: {
		match: /\/api\/revenue\/xero\/ledger-account-mappings\/(.+)$/,
		mock: {
			id: "550e8400-e29b-41d4-a716-446655440000",
			mappableLedgerAccount: "DEFERRED_REVENUE",
			xeroLedgerAccountCode: "201",
			xeroLedgerAccountName: "Updated Deferred Revenue",
			isDefault: !1,
			createdAt: "2026-04-13T10:00:00Z",
			updatedAt: "2026-04-13T10:00:00Z"
		}
	}
}), Bn = n({
	route: ({ id: e }) => `/revenue/xero/ledger-account-mappings/${e}`,
	method: "DELETE",
	invalidateQueries: [Y],
	mocking: {
		match: /\/api\/revenue\/xero\/ledger-account-mappings\/(.+)$/,
		mock: void 0
	}
}), Vn = t({
	route: (e) => {
		let t = Object.entries(e?.customFieldFilters ?? {}).reduce((e, [t, n]) => !t || !n ? e : {
			...e,
			[`customFields.${t}`]: n
		}, {});
		return `/billing-schedules/billing-schedules-csv${i({
			customerId: e?.customerId,
			billingScheduleStatus: e?.billingScheduleStatus,
			autoSendInvoices: e?.autoSendInvoices,
			label: e?.label,
			includeArchivedSchedules: e?.includeArchivedSchedules,
			startingBefore: e?.startingBefore,
			startingAfter: e?.startingAfter,
			endingBefore: e?.endingBefore,
			endingAfter: e?.endingAfter,
			includeOpenEndedSchedules: e?.includeOpenEndedSchedules,
			includeCustomFields: e?.includeCustomFields?.join(","),
			...t
		})}`;
	},
	config: { responseTransform: (e) => e.blob() },
	queryKey: [_n],
	mocking: {
		match: /\/api\/billing-schedules\/billing-schedules-csv(\?(.*))?$/,
		mock: new Blob([""], { type: "text/csv" })
	}
}), Hn = n({
	route: ({ invoiceId: e, lineItemGroupId: t }) => `/invoices/${e}/line-item-groups/${t}`,
	method: "DELETE",
	invalidateQueries: [
		c,
		x,
		a,
		o,
		b
	],
	mocking: {
		match: /\/api\/invoices\/(.+)\/line-item-groups\/(.+)$/,
		mock: {
			id: "4639a112-f821-4bc1-bc2d-6f9ece5b7c0f",
			invoiceId: "cd11218d-fa00-4faa-8684-a43113d076a8",
			title: "Users",
			description: "Charges for users",
			index: 2,
			netTotal: "51.20",
			totalTax: "2.50",
			grossTotal: "101.23",
			taxCategory: {
				id: "cd11218d-fa00-4faa-8684-a43113d076a8",
				name: "Sales Tax"
			}
		}
	}
}), Un = t({
	route: ({ invoiceId: e }) => `/invoices/${e}/line-item-groups/all`,
	queryKey: [b],
	mocking: {
		match: /\/api\/invoices\/(.+)\/line-item-groups\/all/,
		mock: { items: [{
			id: "4639a112-f821-4bc1-bc2d-6f9ece5b7c0f",
			invoiceId: "cd11218d-fa00-4faa-8684-a43113d076a8",
			title: "Users",
			description: "Charges for users",
			index: 2,
			netTotal: "51.20",
			totalTax: "2.50",
			grossTotal: "101.23",
			taxCategory: {
				id: "e2d0d1f3-7d3d-4d4e-8d1e-9f9f9d9f9d9f",
				name: "Sales Tax"
			}
		}] }
	},
	demoModeHandler: (e) => {
		if (d(e.invoiceId)) return Promise.resolve({
			data: { items: [] },
			error: !1,
			res: new Response()
		});
	}
}), Wn = t({
	route: ({ invoiceId: e, ...t }) => `/invoices/${e}/line-item-groups${i(t)}`,
	queryKey: [x],
	mocking: {
		match: /\/api\/invoices\/(.+)\/line-item-groups(\?(.*))?$/,
		mock: {
			items: [{
				id: "4639a112-f821-4bc1-bc2d-6f9ece5b7c0f",
				invoiceId: "cd11218d-fa00-4faa-8684-a43113d076a8",
				title: "Users",
				description: "Charges for users",
				index: 2,
				netTotal: "51.20",
				totalTax: "2.50",
				grossTotal: "101.23",
				taxCategory: {
					id: "e2d0d1f3-7d3d-4d4e-8d1e-9f9f9d9f9d9f",
					name: "Sales Tax"
				}
			}],
			pagination: {
				after: "",
				before: "",
				totalResultSize: 1
			}
		}
	}
}), Gn = n({
	route: ({ invoiceId: e }) => `/invoices/${e}/line-item-groups`,
	method: "POST",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [
		c,
		x,
		a,
		o,
		b
	],
	mocking: {
		match: /\/api\/invoices\/(.+)\/line-item-groups$/,
		mock: {
			id: "4639a112-f821-4bc1-bc2d-6f9ece5b7c0f",
			invoiceId: "cd11218d-fa00-4faa-8684-a43113d076a8",
			title: "Users",
			description: "Charges for users",
			index: 2,
			netTotal: "51.20",
			totalTax: "2.50",
			grossTotal: "101.23",
			taxCategory: {
				id: "fe2fcd0b-4c53-45c7-b2ae-b6c1a7d21e95",
				name: "Sales Tax"
			}
		}
	}
}), Kn = n({
	route: ({ invoiceId: e, id: t }) => `/invoices/${e}/line-item-groups/${t}`,
	method: "PUT",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [
		c,
		x,
		a
	],
	mocking: {
		match: /\/api\/invoices\/(.+)\/line-item-groups\/(.+)$/,
		mock: {
			id: "4639a112-f821-4bc1-bc2d-6f9ece5b7c0f",
			invoiceId: "cd11218d-fa00-4faa-8684-a43113d076a8",
			title: "Users",
			description: "Charges for users",
			index: 2,
			netTotal: "51.20",
			totalTax: "2.50",
			grossTotal: "101.23",
			taxCategory: {
				id: "cd11218d-fa00-4faa-8684-a43113d076a8",
				name: "Sales Tax"
			}
		}
	}
}), qn = /* @__PURE__ */ e({
	deleteLineItemGroup: () => Hn,
	getAllLineItemGroups: () => Un,
	getLineItemGroups: () => Wn,
	postLineItemGroup: () => Gn,
	putLineItemGroup: () => Kn
}), Jn = n({
	route: ({ invoiceId: e, lineItemId: t }) => `/invoices/${e}/line-items/${t}`,
	method: "DELETE",
	invalidateQueries: [
		c,
		a,
		o,
		x,
		b
	],
	mocking: {
		match: /\/api\/invoices\/(.+)\/line-items\/(.+)$/,
		mock: {
			id: "af60cab3-812d-4250-a051-0fb7133a00c7",
			invoiceId: "cd11218d-fa00-4faa-8684-a43113d076a8",
			title: "Ferraris",
			description: "Red",
			quantity: "2",
			rate: "20000.10",
			taxRate: "0.2",
			servicePeriodStart: "2022-10-20T00:00:00Z",
			servicePeriodEnd: "2022-10-24T00:00:00Z",
			servicePeriod: {
				startDate: "2022-10-20",
				endDate: "2022-10-24"
			},
			index: 2,
			groupId: "cd11218d-fa00-4faa-8684-a43113d076a8",
			netTotal: "51.20",
			totalTax: "2.50",
			grossTotal: "101.23",
			priceId: "fe2fcd0b-4c53-45c7-b2ae-b6c1a7d21e95",
			rateDisplay: "ABSOLUTE",
			externalIds: [{
				key: "Xero",
				value: "123"
			}],
			revenueClassification: "EARNED",
			creditGrantId: "fe2fcd0b-4c53-45c7-b2ae-b6c1a7d21e95",
			revenueRecognitionMethod: "USAGE"
		}
	}
}), Yn = t({
	route: ({ invoiceId: e }) => `/invoices/${e}/line-items/all`,
	queryKey: [o],
	mocking: {
		match: /\/api\/invoices\/(.+)\/line-items\/all/,
		mock: { items: [{
			id: "af60cab3-812d-4250-a051-0fb7133a00c7",
			invoiceId: "cd11218d-fa00-4faa-8684-a43113d076a8",
			title: "Ferraris",
			description: "Red",
			quantity: "2",
			rate: "20000.10",
			taxRate: "0.2",
			servicePeriodStart: "2022-10-20T00:00:00Z",
			servicePeriodEnd: "2022-10-24T00:00:00Z",
			servicePeriod: {
				startDate: "2022-10-20",
				endDate: "2022-10-24"
			},
			index: 2,
			groupId: "cd11218d-fa00-4faa-8684-a43113d076a8",
			netTotal: "51.20",
			totalTax: "2.50",
			grossTotal: "101.23",
			priceId: "fe2fcd0b-4c53-45c7-b2ae-b6c1a7d21e95",
			rateDisplay: "ABSOLUTE",
			externalIds: [{
				key: "Xero",
				value: "123"
			}],
			revenueClassification: "EARNED",
			creditGrantIds: ["fe2fcd0b-4c53-45c7-b2ae-b6c1a7d21e95"]
		}] }
	},
	demoModeHandler: (e) => {
		if (d(e.invoiceId)) return Promise.resolve({
			data: { items: [] },
			error: !1,
			res: new Response()
		});
	}
}), Xn = t({
	route: ({ invoiceId: e, ...t }) => `/invoices/${e}/line-items${i(t)}`,
	queryKey: [a],
	mocking: {
		match: /\/api\/invoices\/(.+)\/line-items(\?(.*))?$/,
		mock: {
			items: [{
				id: "af60cab3-812d-4250-a051-0fb7133a00c7",
				invoiceId: "cd11218d-fa00-4faa-8684-a43113d076a8",
				title: "Ferraris",
				description: "Red",
				quantity: "2",
				rate: "20000.10",
				taxRate: "0.2",
				servicePeriodStart: "2022-10-20T00:00:00Z",
				servicePeriodEnd: "2022-10-24T00:00:00Z",
				servicePeriod: {
					startDate: "2022-10-20",
					endDate: "2022-10-24"
				},
				index: 2,
				groupId: "cd11218d-fa00-4faa-8684-a43113d076a8",
				netTotal: "51.20",
				totalTax: "2.50",
				grossTotal: "101.23",
				priceId: "fe2fcd0b-4c53-45c7-b2ae-b6c1a7d21e95",
				rateDisplay: "ABSOLUTE",
				externalIds: [{
					key: "Xero",
					value: "123"
				}],
				revenueClassification: "EARNED",
				creditGrantId: "fe2fcd0b-4c53-45c7-b2ae-b6c1a7d21e95"
			}],
			pagination: {
				after: "",
				before: "",
				totalResultSize: 1
			}
		}
	}
}), Zn = n({
	route: ({ invoiceId: e }) => `/invoices/${e}/line-items`,
	method: "POST",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [
		c,
		a,
		o,
		x,
		b
	],
	mocking: {
		match: /\/api\/invoices\/(.+)\/line-items$/,
		mock: {
			id: "af60cab3-812d-4250-a051-0fb7133a00c7",
			invoiceId: "cd11218d-fa00-4faa-8684-a43113d076a8",
			title: "Ferraris",
			description: "Red",
			quantity: "2",
			rate: "20000.10",
			taxRate: "0.2",
			servicePeriodStart: "2022-10-20T00:00:00Z",
			servicePeriodEnd: "2022-10-24T00:00:00Z",
			servicePeriod: {
				startDate: "2022-10-20",
				endDate: "2022-10-24"
			},
			index: 2,
			groupId: "cd11218d-fa00-4faa-8684-a43113d076a8",
			netTotal: "51.20",
			totalTax: "2.50",
			grossTotal: "101.23",
			priceId: "fe2fcd0b-4c53-45c7-b2ae-b6c1a7d21e95",
			rateDisplay: "ABSOLUTE",
			externalIds: [{
				key: "Xero",
				value: "123"
			}],
			revenueClassification: "EARNED",
			creditGrantId: "fe2fcd0b-4c53-45c7-b2ae-b6c1a7d21e95",
			revenueRecognitionMethod: "USAGE"
		}
	}
}), Qn = n({
	route: ({ invoiceId: e, id: t }) => `/invoices/${e}/line-items/${t}`,
	method: "PUT",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [
		c,
		a,
		o,
		x,
		b
	],
	mocking: {
		match: /\/api\/invoices\/(.+)\/line-items\/(.+)$/,
		mock: {
			id: "af60cab3-812d-4250-a051-0fb7133a00c7",
			invoiceId: "cd11218d-fa00-4faa-8684-a43113d076a8",
			title: "Ferraris",
			description: "Red",
			quantity: "2",
			rate: "20000.10",
			taxRate: "0.2",
			servicePeriodStart: "2022-10-20T00:00:00Z",
			servicePeriodEnd: "2022-10-24T00:00:00Z",
			servicePeriod: {
				startDate: "2022-10-20",
				endDate: "2022-10-24"
			},
			index: 2,
			groupId: "cd11218d-fa00-4faa-8684-a43113d076a8",
			netTotal: "51.20",
			totalTax: "2.50",
			grossTotal: "101.23",
			priceId: "fe2fcd0b-4c53-45c7-b2ae-b6c1a7d21e95",
			rateDisplay: "ABSOLUTE",
			externalIds: [{
				key: "Xero",
				value: "123"
			}],
			revenueClassification: "EARNED",
			creditGrantId: "fe2fcd0b-4c53-45c7-b2ae-b6c1a7d21e95",
			revenueRecognitionMethod: "STRAIGHT_LINE"
		}
	}
}), $n = /* @__PURE__ */ e({
	deleteLineItem: () => Jn,
	getAllLineItems: () => Yn,
	getLineItems: () => Xn,
	postLineItem: () => Zn,
	putLineItem: () => Qn
}), X = "workflows", Z = "agentsSettings", er = "invoiceReminderVariableValues", tr = "watchtower.invoke-task-executor", Q = {
	id: "123e4567-e89b-12d3-a456-426614174000",
	type: "CONTRACT_EXTRACTION",
	status: "IN_PROGRESS",
	tasks: [{
		id: "123e4567-e89b-12d3-a456-426614174111",
		workflowId: "123e4567-e89b-12d3-a456-426614174000",
		input: [],
		output: [],
		type: "CONTRACT_REVIEW",
		status: "COMPLETED",
		createdAt: "2023-10-15T14:30:00Z",
		updatedAt: "2023-10-15T14:35:00Z",
		completedAt: "2023-10-15T14:35:00Z"
	}],
	workflowEvents: [{
		id: "123e4567-e89b-12d3-a456-426614174999",
		workflowId: "123e4567-e89b-12d3-a456-426614174000",
		type: "TASK_STARTED",
		description: "Task was created successfully",
		createdAt: "2023-10-15T14:30:00Z",
		updatedAt: "2023-10-15T14:30:00Z"
	}],
	createdAt: "2023-10-15T14:30:00Z",
	updatedAt: "2023-10-15T14:35:00Z"
}, nr = {
	email: "email-123@example.com",
	createdAt: "2025-09-01T12:00:00.000Z",
	updatedAt: "2025-09-01T12:00:00.000Z"
}, rr = t({
	route: ({ statuses: e = [], ...t } = {}) => `/watchtower/workflows${i({
		...t,
		statuses: e.length ? e.join(",") : void 0
	})}`,
	queryKey: [X],
	mocking: {
		match: /\/api\/watchtower\/workflows(\?(.*))?$/,
		mock: {
			items: [Q],
			pagination: {
				after: "",
				before: "",
				totalResultSize: 1
			}
		}
	}
}), ir = t({
	route: ({ workflowId: e }) => `/watchtower/workflows/${e}`,
	queryKey: [X],
	mocking: {
		match: /\/api\/watchtower\/workflows\/([^\/]+?)$/,
		mock: Q
	}
}), ar = n({
	route: () => "/watchtower/agents/enable",
	method: "POST",
	invalidateQueries: [Z],
	mocking: {
		match: /\/api\/watchtower\/agents\/enable$/,
		mock: nr
	}
}), or = t({
	route: () => "/watchtower/agents",
	queryKey: [Z],
	mocking: {
		match: /\/api\/watchtower\/agents$/,
		mock: nr
	}
}), sr = n({
	route: () => "/watchtower/agents/disable",
	method: "DELETE",
	invalidateQueries: [Z],
	mocking: {
		match: /\/api\/watchtower\/agents\/disable$/,
		mock: null
	}
}), cr = n({
	route: ({ workflowId: e }) => `/watchtower/workflows/${e}/feedback`,
	method: "POST",
	body: (e) => JSON.stringify(e.body),
	invalidateQueries: [],
	mocking: {
		match: /\/api\/watchtower\/workflows\/(.+)\/feedback$/,
		mock: void 0
	}
}), lr = t({
	route: () => "/watchtower/invoice-reminder-variable-resolution",
	method: "POST",
	body: (e) => JSON.stringify(e),
	queryKey: [er],
	paramQueryKeyTransform: ({ invoice: e }) => ({
		invoiceId: e?.id,
		customerId: e?.customerId
	}),
	mocking: {
		match: /\/api\/watchtower\/invoice-reminder-variable-resolution$/,
		mock: {
			customerName: "Acme Inc",
			contactEmail: "ap@acme.example.com",
			contactName: "Acme AP",
			invoiceNumber: "INV-2025-0001",
			amount: "£1,234.50",
			dueDate: "20 May 2026",
			daysLate: "9",
			url: "https://portal.example.com/invoice"
		}
	}
}), ur = t({
	route: () => "/watchtower/invoke-task-executor",
	method: "POST",
	body: (e) => JSON.stringify(e),
	queryKey: [tr],
	mocking: {
		match: /\/api\/watchtower\/invoke-task-executor$/,
		mock: {
			status: "COMPLETED",
			outputData: {},
			reasonForIncompletion: null
		}
	}
}), dr = /* @__PURE__ */ e({
	deleteAgentsDisable: () => sr,
	getAgentsSettings: () => or,
	getWorkflow: () => ir,
	getWorkflows: () => rr,
	postAgentsEnable: () => ar,
	postContractIntakeFeedback: () => cr,
	postInvoiceReminderVariableResolution: () => lr,
	postInvokeTaskExecutor: () => ur
}), fr = { getSelf: t({
	route: () => "/self",
	queryKey: ["self"],
	mocking: {
		match: /\/api\/self(\?(.*))?$/,
		mock: {
			sequenceUser: {
				id: "14472ebf-8f7a-4838-8be7-5963bf8ce15a",
				email: "jane.cadwallader@example.com"
			},
			sequenceAccounts: ["84225102-a8dc-4598-9d83-3f91ebbb163d"],
			launchDarklyHash: "exampleLaunchDarklyHash",
			roles: [{
				roleName: "admin",
				permissions: [
					{
						resource: "org.customer",
						actions: [
							"create",
							"read",
							"update",
							"delete",
							"archive",
							"sync"
						]
					},
					{
						resource: "org.billing",
						actions: [
							"create",
							"read",
							"update",
							"delete",
							"archive",
							"start",
							"sync"
						]
					},
					{
						resource: "org.product",
						actions: [
							"create",
							"read",
							"update",
							"delete",
							"archive"
						]
					},
					{
						resource: "org.invoice",
						actions: [
							"create",
							"read",
							"update",
							"delete",
							"archive",
							"finalize",
							"send",
							"sync"
						]
					},
					{
						resource: "org.creditNote",
						actions: [
							"create",
							"read",
							"update",
							"delete",
							"archive",
							"finalize",
							"send",
							"sync"
						]
					},
					{
						resource: "org.quote",
						actions: [
							"create",
							"read",
							"update",
							"delete",
							"archive",
							"publish",
							"accept",
							"execute",
							"sync"
						]
					},
					{
						resource: "org.revenueRecognition",
						actions: [
							"create",
							"read",
							"update",
							"delete",
							"archive"
						]
					},
					{
						resource: "org.usage",
						actions: [
							"create",
							"read",
							"update",
							"delete",
							"archive"
						]
					},
					{
						resource: "org.settings",
						actions: [
							"create",
							"read",
							"update",
							"delete",
							"archive",
							"invite"
						]
					},
					{
						resource: "org.integration",
						actions: [
							"create",
							"read",
							"update",
							"delete",
							"archive"
						]
					},
					{
						resource: "org.watchtower",
						actions: [
							"create",
							"read",
							"update",
							"delete",
							"archive"
						]
					},
					{
						resource: "org.bulkAction",
						actions: ["create", "read"]
					}
				]
			}]
		}
	}
}) }, pr = { postFeedback: n({
	route: () => "/feedback",
	method: "POST",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [],
	mocking: {
		match: /\/api\/feedback$/,
		mock: { message: "ok" }
	}
}) }, mr = "credit-grants-v2", hr = {
	getCreditGrant: t({
		route: ({ id: e }) => `/credit-grants/${e}`,
		queryKey: [m, mr],
		mocking: {
			match: /\/api\/credit-grants\/[^/]+$/,
			mock: {
				id: "0199ca8a-e7e8-73b3-bd69-a316a23231a0",
				sequenceAccountId: "dce9ae85-d8d0-42b4-bcad-f221a64363c6",
				customerId: "61b083e0-1faa-47ca-9aeb-6205da8f6c47",
				scope: "SCHEDULE",
				billingScheduleId: "0199ca86-560e-7ac4-999f-bee364f7e4e7",
				phaseId: "0199ca88-1a2b-7c3d-8e4f-5a6b7c8d9e0f",
				name: "Monthly usage credits",
				creditUnitType: "CURRENCY",
				currency: "GBP",
				amount: 100,
				remainingBalance: 100,
				status: "ACTIVE",
				costOfCredit: 0,
				effectiveDate: "2026-01-01",
				expiryDate: "2026-01-31",
				createdAt: "2026-01-01T10:00:00Z",
				updatedAt: "2026-01-01T10:00:00Z",
				grantRefreshFrequency: "MONTHLY",
				billingFrequency: "MONTHLY",
				rolloverMode: "NONE",
				priceIds: ["0199ca89-2d9e-7e3d-914c-7de86e8fc7ce"],
				integrationIds: []
			}
		}
	}),
	getCreditGrants: t({
		route: (e) => `/credit-grants${i(e)}`,
		queryKey: [m, mr],
		mocking: {
			match: /\/api\/credit-grants(\?(.*))?$/,
			mock: {
				items: [{
					id: "0199ca8a-e7e8-73b3-bd69-a316a23231d3",
					sequenceAccountId: "dce9ae85-d8d0-42b4-bcad-f221a64363c6",
					customerId: "61b083e0-1faa-47ca-9aeb-6205da8f6c47",
					scope: "CUSTOMER",
					name: "Goodwill credit",
					creditUnitType: "CURRENCY",
					currency: "GBP",
					amount: 100,
					remainingBalance: 90,
					status: "ACTIVE",
					costOfCredit: 90,
					effectiveDate: "2026-01-01",
					expiryDate: "2026-12-31",
					createdAt: "2026-01-01T10:00:00Z",
					updatedAt: "2026-01-01T10:00:00Z",
					grantRefreshFrequency: "NONE",
					billingFrequency: "ONE_TIME",
					rolloverMode: "NONE",
					priceIds: [],
					integrationIds: []
				}, {
					id: "0199ca8a-e7e8-73b3-bd69-a316a23231a0",
					sequenceAccountId: "dce9ae85-d8d0-42b4-bcad-f221a64363c6",
					customerId: "61b083e0-1faa-47ca-9aeb-6205da8f6c47",
					scope: "SCHEDULE",
					billingScheduleId: "0199ca86-560e-7ac4-999f-bee364f7e4e7",
					phaseId: "0199ca88-1a2b-7c3d-8e4f-5a6b7c8d9e0f",
					name: "Monthly usage credits",
					creditUnitType: "CURRENCY",
					currency: "GBP",
					amount: 100,
					remainingBalance: 100,
					status: "ACTIVE",
					costOfCredit: 100,
					effectiveDate: "2026-01-01",
					expiryDate: "2026-01-31",
					createdAt: "2026-01-01T10:00:00Z",
					updatedAt: "2026-01-01T10:00:00Z",
					grantRefreshFrequency: "MONTHLY",
					billingFrequency: "MONTHLY",
					rolloverMode: "NONE",
					priceIds: ["0199ca89-2d9e-7e3d-914c-7de86e8fc7ce"],
					integrationIds: []
				}],
				pagination: {
					after: "",
					before: "",
					totalResultSize: 2
				}
			}
		}
	})
}, gr = "integrations", _r = n({
	route: () => "/integrations/netsuite/credentials",
	method: "POST",
	body: (e) => JSON.stringify(e),
	invalidateQueries: [gr],
	mocking: {
		match: /\/api\/integrations\/netsuite\/credentials$/,
		status: 201,
		mock: {
			netsuiteAccountId: "1234567_SB1",
			subsidiaryId: "2",
			consumerKey: "consumer-key",
			certificateId: "AbCdEfGhIjKlMnOp",
			defaultItemIncomeAccountId: "42",
			defaultTaxScheduleId: "1",
			prepaidCreditItemId: null,
			commitmentItemId: null,
			creditGrantItemId: null,
			salesTaxItemId: null,
			deferredRevenueItemId: null,
			state: "CONNECTED",
			enabled: !0,
			authFailure: !1
		}
	}
}), vr = n({
	route: () => "/integrations/netsuite/credentials/validate",
	method: "POST",
	body: (e) => JSON.stringify(e),
	invalidateQueries: [],
	mocking: {
		match: /\/api\/integrations\/netsuite\/credentials\/validate$/,
		mock: { isValid: !0 }
	}
}), yr = "netsuiteIncomeAccounts", br = "netsuiteItems", xr = "netsuiteItem", Sr = t({
	route: () => "/integrations/netsuite/accounts",
	queryKey: [yr],
	mocking: {
		match: /\/api\/integrations\/netsuite\/accounts$/,
		mock: { items: [{
			id: "55",
			name: "Sales Revenue",
			code: "4000",
			accountType: "Income",
			externalUrl: "https://1234567.app.netsuite.com/app/accounting/account/account.nl?id=55"
		}, {
			id: "56",
			name: "Interest Income",
			code: "4100",
			accountType: "OthIncome",
			externalUrl: "https://1234567.app.netsuite.com/app/accounting/account/account.nl?id=56"
		}] }
	}
}), Cr = t({
	route: ({ id: e }) => `/integrations/netsuite/items/${e}`,
	queryKey: [xr],
	mocking: {
		match: /\/api\/integrations\/netsuite\/items\/(?!search)[^/?]+$/,
		mock: {
			id: "42",
			name: "Usage credits – straight line"
		}
	}
}), wr = t({
	route: (e) => `/integrations/netsuite/items/search${i(e)}`,
	queryKey: [br],
	mocking: {
		match: /\/api\/integrations\/netsuite\/items\/search(\?.*)?$/,
		mock: { items: [{
			id: "42",
			name: "Usage credits – straight line"
		}, {
			id: "43",
			name: "Platform fee"
		}] }
	}
}), Tr = {
	postStoreNetsuiteCredentials: _r,
	postTestNetsuiteCredentials: vr,
	getNetsuiteIncomeAccounts: Sr,
	putNetsuiteSettings: n({
		route: () => "/integrations/netsuite/settings",
		method: "PUT",
		body: (e) => JSON.stringify(e),
		invalidateQueries: [gr],
		mocking: {
			match: /\/api\/integrations\/netsuite\/settings$/,
			mock: {
				subsidiaryId: "2",
				defaultItemIncomeAccountId: "42",
				defaultTaxScheduleId: "1",
				prepaidCreditItemId: null,
				commitmentItemId: null,
				creditGrantItemId: null,
				salesTaxItemId: null,
				deferredRevenueItemId: null
			}
		}
	}),
	searchNetsuiteItems: wr,
	getNetsuiteItem: Cr
}, Er = n({
	route: ({ id: e }) => `/users/${e}/roles`,
	method: "PUT",
	body: ({ roles: e }) => JSON.stringify({ roles: e }),
	invalidateQueries: ["users"],
	mocking: {
		match: /\/api\/users\/[^\/]+\/roles$/,
		mock: {
			id: "7b1f28b9-a4ad-450b-a0ea-fd647d5109b2",
			email: "john@example.xyz",
			sequenceAccountIds: ["83da2ca4-49c7-4d81-9c9a-ba5be11768b0"],
			state: "active",
			roles: []
		}
	}
}), Dr = /* @__PURE__ */ e({ putUpdateUserRoles: () => Er }), Or = "sequenceAccountMembers", kr = "sequenceLabsSettings", Ar = n({
	route: () => "/sequence-accounts/invite",
	body: ({ email: e, roles: t }) => JSON.stringify({
		email: e,
		roles: t
	}),
	invalidateQueries: [Or],
	method: "POST",
	mocking: {
		match: /\/api\/sequence-accounts\/invite$/,
		mock: void 0
	}
}), jr = t({
	route: () => "/labs/settings",
	queryKey: [kr],
	mocking: {
		match: /\/api\/labs\/settings$/,
		mock: {
			id: "613eed4d-5bdf-4fc1-a40a-aa2540b2cdc6",
			sequenceAccountId: "5eb477d7-f421-4d30-b99c-757c81021b92",
			labsEnabled: !0,
			mcp: {
				enabled: !0,
				serverName: "Sequence",
				serverUrl: "https://eu.sequencehq.com/mcp"
			},
			emailAgent: {
				enabled: !0,
				emailAddress: "acme-inc@agents.seqhq.io"
			},
			updatedAt: "2026-01-01T00:00:00Z"
		}
	}
}), Mr = n({
	route: () => "/labs/settings",
	method: "PUT",
	body: (e) => JSON.stringify({
		labsEnabled: e.labsEnabled,
		mcp: e.mcp,
		emailAgent: e.emailAgent
	}),
	invalidateQueries: [kr],
	mocking: {
		match: /\/api\/labs\/settings$/,
		mock: {
			id: "613eed4d-5bdf-4fc1-a40a-aa2540b2cdc6",
			sequenceAccountId: "5eb477d7-f421-4d30-b99c-757c81021b92",
			labsEnabled: !0,
			mcp: {
				enabled: !0,
				serverName: "Sequence",
				serverUrl: "https://eu.sequencehq.com/mcp"
			},
			emailAgent: {
				enabled: !0,
				emailAddress: "acme-inc@agents.seqhq.io"
			},
			updatedAt: "2026-01-01T00:00:00Z"
		}
	}
}), Nr = /* @__PURE__ */ e({
	getSequenceLabsSettings: () => jr,
	postSequenceAccountInvite: () => Ar,
	putSequenceLabsSettings: () => Mr
}), $ = "activityLogs", Pr = "activityLogsRbacCsvDownload", Fr = {
	id: "aa0e8400-e29b-41d4-a716-446655440005",
	sequenceAccountId: "bb0e8400-e29b-41d4-a716-446655440006",
	activityType: "NOTIFICATION",
	apiVersion: "VERSION_9999_01_01",
	origin: "API_CALL",
	createdAt: "2024-01-01T10:00:00Z",
	activityLogItems: [{
		id: "880e8400-e29b-41d4-a716-446655440003",
		activityLogId: "990e8400-e29b-41d4-a716-446655440004",
		verb: "CREATED",
		name: "Invoice Created",
		summary: "A new invoice was created for customer",
		reason: "New billing cycle started",
		metadata: [],
		activityLogActor: {
			id: "550e8400-e29b-41d4-a716-446655440000",
			entityType: "USER",
			entityId: "550e8400-e29b-41d4-a716-446655440123",
			email: "example@sequencehq.com"
		},
		activityLogObject: {
			id: "660e8400-e29b-41d4-a716-446655440001",
			entityType: "INVOICE",
			entityId: "550e8400-e29b-41d4-a716-446655440456"
		},
		activityLogTarget: {
			id: "770e8400-e29b-41d4-a716-446655440002",
			entityType: "SEQUENCE_USER",
			entityId: "550e8400-e29b-41d4-a716-446655440789"
		}
	}]
}, Ir = t({
	route: (e) => `/activity-logs${i(e)}`,
	queryKey: [$],
	mocking: {
		match: /\/api\/activity-logs(\?(.*))?$/,
		mock: {
			items: [Fr],
			pagination: {
				after: "",
				before: "",
				totalResultSize: 1
			}
		}
	}
}), Lr = t({
	route: ({ id: e }) => `/activity-logs/${e}`,
	queryKey: [$],
	mocking: {
		match: /\/api\/activity-logs\/([^\/]+?)$/,
		mock: Fr
	}
}), Rr = t({
	route: () => "/activity-logs/rbac-csv",
	config: { responseTransform: (e) => e.blob() },
	queryKey: [Pr],
	mocking: {
		match: /\/api\/activity-logs\/rbac-csv$/,
		mock: new Blob([""], { type: "text/csv" })
	}
}), zr = n({
	route: ({ activityLogObjectEntityId: e }) => `/activity-logs/${e}/notes`,
	method: "POST",
	body: ({ body: e }) => JSON.stringify(e),
	invalidateQueries: [$],
	mocking: {
		match: /\/api\/activity-logs\/([^\/]+?)\/notes$/,
		mock: null
	}
}), Br = n({
	route: ({ activityLogId: e }) => `/activity-logs/${e}/notes`,
	method: "DELETE",
	invalidateQueries: [$],
	mocking: {
		match: /\/api\/activity-logs\/([^\/]+?)\/notes$/,
		mock: void 0
	}
}), Vr = /* @__PURE__ */ e({
	deleteActivityLogNote: () => Br,
	getActivityLog: () => Lr,
	getActivityLogs: () => Ir,
	getActivityLogsRbacCsvDownload: () => Rr,
	postActivityLogNote: () => zr
}), Hr = n({
	route: ({ quoteId: e }) => `/quotes/${e}/send-reminders`,
	method: "POST",
	invalidateQueries: [],
	mocking: {
		match: /\/api\/quotes\/(.+)\/send-reminders$/,
		mock: void 0
	}
}), Ur = t({
	route: ({ quoteId: e }) => `/quotes/${e}/analytics`,
	queryKey: [_t],
	mocking: {
		match: /\/api\/quotes\/([^\/]+?)\/analytics$/,
		mock: {
			totalViews: 34,
			uniqueViewers: [{
				visitorIdentifier: "id-1",
				lastViewedAt: "2026-01-01T12:00:00.000Z",
				loginType: "SEQUENCE_USER",
				email: "user-1@example.com"
			}],
			viewsByDay: [{
				date: "2026-01-01",
				totalViews: 34
			}]
		}
	}
}), Wr = /* @__PURE__ */ e({
	getQuoteAnalytics: () => Ur,
	postQuoteSendReminders: () => Hr
}), Gr = {
	id: "inv-123",
	sequenceAccountId: "seq-123",
	status: "DRAFT",
	currency: "GBP",
	netTotal: "1000",
	grossTotal: "1000",
	totalTax: "0",
	balance: "1000",
	balanceVersion: 0,
	customerId: "cus-123",
	customerEmails: ["beep@boop.com"],
	customerLegalCompanyName: "Test Co.",
	customerBillingAddress: {
		line1: "123 Fake St",
		town: "Springfield",
		postcode: "12345",
		country: "GB"
	},
	customerShippingAddress: {
		line1: "123 Fake St",
		town: "Springfield",
		postcode: "12345",
		country: "GB"
	},
	isCustomerArchived: !1,
	metadata: [{
		key: "string",
		value: "string"
	}],
	paymentStatus: "PAID",
	createdAt: "2024-01-05",
	updatedAt: "2024-01-05",
	creditNoteIds: [],
	currentlyApplied: null,
	appliedCreditGrants: [],
	projectedCreditGrants: [],
	linkedServices: [{
		externalId: "string",
		externalService: "Xero",
		externalUrl: "https://example.com",
		syncTime: "2024-01-05T12:00:00Z"
	}],
	accountingDate: "2024-02-01",
	paymentTermDays: 30,
	dueDateSource: "CALCULATED",
	dueDatePolicy: {
		type: "PAYMENT_TERMS",
		paymentTermDays: 30
	},
	dueDateStatus: "SET",
	customerTaxStatus: "TAX_EXEMPT",
	renderSettings: { paymentLinkDisplay: "HIDE_PAYMENT_LINK" }
}, Kr = {
	getInvoice: t({
		route: (e) => `/invoices/${e.id}`,
		queryKey: [c],
		mocking: {
			match: /\/api\/invoices\/(?!list-summary)([^\/]+)$/,
			mock: {
				...Gr,
				billingRunId: "brr-123",
				paymentTermDays: 30,
				integrationPaymentStatuses: {
					stripe: "PAID",
					goCardless: "IN_PROGRESS"
				}
			}
		},
		demoModeHandler: (e) => {
			if (d(e.id)) return Promise.resolve({
				data: {
					...pe,
					paymentTermDays: 30,
					dueDateSource: "CALCULATED",
					dueDatePolicy: {
						type: "PAYMENT_TERMS",
						paymentTermDays: 30
					},
					dueDateStatus: "SET"
				},
				error: !1,
				res: new Response()
			});
		}
	}),
	getInvoices: t({
		route: (e) => `/invoices${i(e)}`,
		queryKey: [c],
		mocking: {
			match: /\/api\/invoices(\?(.*))?$/,
			mock: {
				items: [{
					id: "ba37a392-7054-4dae-ab37-6fee9e23fe06",
					sequenceAccountId: "af9b5988-1d7b-45f6-a188-326df5e59b24",
					status: "DRAFT",
					currency: "GBP",
					invoiceNumber: "INV2",
					dueDate: "2022-11-05",
					purchaseOrderNumber: "PO123",
					reference: "ref",
					customerEmails: ["customer@example.com"],
					customerLegalCompanyName: "Facebook",
					customerBillingAddress: {
						line1: "Flat 1",
						line2: "15 Yemen Road",
						town: "Yemen",
						state: "CA",
						postcode: "YE1 2YE",
						country: "YE"
					},
					customerShippingAddress: {
						line1: "742 Evergreen Terrace",
						line2: "",
						town: "Springfield",
						state: "CA",
						postcode: "12345",
						country: "US"
					},
					isCustomerArchived: !1,
					memo: "Thanks",
					paymentOptions: ["BANK_TRANSFER"],
					billingPeriod: {
						start: "2022-10-01",
						endInclusive: "2022-10-30"
					},
					customerId: "b3c0cf23-6717-4cdc-b190-acf8aa6ccd8a",
					totalTax: "2",
					netTotal: "12",
					grossTotal: "10",
					metadata: [{
						key: "example-label",
						value: "label-value"
					}],
					paymentStatus: "UNPAID",
					createdAt: "2022-10-30T00:00:00Z",
					updatedAt: "2022-10-30T00:00:00Z",
					creditNoteIds: ["941272d1-f840-4e16-b698-0cd455c81e0e"],
					linkedServices: [{
						externalId: "ID",
						externalService: "Xero",
						syncTime: "2022-06-28T16:47:00Z"
					}],
					merchantDetails: {
						address: {
							line1: "Flat 1",
							line2: "123 Fake Street",
							town: "New York",
							state: "NY",
							postcode: "AB1 2EF",
							country: "US"
						},
						phoneNumber: "0800001066",
						email: "donald@example.com",
						taxId: "TAX",
						iban: "GB33BUKB20201555555555",
						ukAccountDetails: {
							sortCode: "123456",
							accountNumber: "12345678"
						},
						usAchDetails: {
							accountNumber: "12345678",
							accountName: "John Doe",
							bankName: "Chase",
							bankRoutingNumber: "123456789"
						},
						usWireDetails: {
							accountNumber: "12345678",
							accountName: "John Doe",
							bankName: "Chase",
							bankRoutingNumber: "123456789",
							swiftCode: "CHASUS33",
							bankAddress: {
								line1: "JP Morgan Chase",
								town: "New York City",
								state: "NY",
								postcode: "10017",
								country: "US"
							}
						},
						legalCompanyName: "The Merchant",
						customFields: [],
						includeBeneficiaryAddressInPaymentDetails: !1
					},
					accountingDate: "2022-10-05",
					customerTaxStatus: "TAXED",
					renderSettings: { paymentLinkDisplay: "HIDE_PAYMENT_LINK" }
				}],
				pagination: {
					after: "MDE4NDUyNjYtNmQ2NC03N2M4LTlhZGYtNDQ4N2Q5NGQxNDU3",
					before: "MDE4NDQyMWUtYTljYy03MTFiLWFmOTMtYmYwNTExZDRkODMz",
					totalResultSize: 10
				}
			}
		}
	}),
	getInvoiceSummary: t({
		route: (e) => `/invoices/summary${i(e)}`,
		queryKey: [c, me],
		mocking: {
			match: /\/api\/invoices\/summary(\?(.*))?$/,
			mock: { totalsByCurrency: [{
				currency: "GBP",
				invoiceCount: 12,
				grossTotal: 15400
			}, {
				currency: "USD",
				invoiceCount: 3,
				grossTotal: 980.5
			}] }
		}
	}),
	getInvoicesListSummary: t({
		route: (e) => `/invoices/list-summary${i(e)}`,
		queryKey: [c, re],
		mocking: {
			match: /\/api\/invoices\/list-summary(\?(.*))?$/,
			mock: {
				items: [{
					id: "ba37a392-7054-4dae-ab37-6fee9e23fe06",
					invoiceNumber: "INV2",
					status: "DRAFT",
					paymentStatus: "UNPAID",
					currency: "GBP",
					grossTotal: "10",
					customerId: "b3c0cf23-6717-4cdc-b190-acf8aa6ccd8a",
					customerLegalCompanyName: "Facebook",
					billingScheduleId: "7c8f0b1e-3d2a-4f6c-9a1b-2e3f4a5b6c7d",
					billingPeriod: {
						start: "2022-10-01",
						endInclusive: "2022-10-30"
					},
					dueDate: "2022-11-05",
					dueDateSource: "CALCULATED",
					dueDatePolicy: {
						type: "PAYMENT_TERMS",
						paymentTermDays: 30
					},
					dueDateStatus: "SET",
					accountingDate: "2022-10-05",
					links: [{
						externalId: "ID",
						externalService: "Xero",
						syncTime: "2022-06-28T16:47:00Z"
					}]
				}],
				pagination: {
					after: "MDE4NDUyNjYtNmQ2NC03N2M4LTlhZGYtNDQ4N2Q5NGQxNDU3",
					before: "MDE4NDQyMWUtYTljYy03MTFiLWFmOTMtYmYwNTExZDRkODMz",
					totalResultSize: 10
				}
			}
		}
	}),
	putInvoice: n({
		route: ({ id: e }) => `/invoices/${e}`,
		method: "PUT",
		body: (e) => JSON.stringify(e.body),
		invalidateQueries: [c, ae],
		mocking: {
			match: /\/api\/invoices\/(.+)$/,
			mock: Gr
		}
	}),
	postFinalizeInvoice: he,
	postFinalizeAndSendInvoice: oe,
	postConvertInvoiceToDraft: n({
		route: (e) => `/invoices/${e.id}/draft`,
		method: "POST",
		invalidateQueries: [ie],
		mocking: {
			match: /\/api\/invoices\/(.+)\/draft$/,
			mock: {
				id: "e007e884-5100-4183-8355-4771865cb4dd",
				sequenceAccountId: "1986c663-9ee9-4811-bfbf-57d2ad666096",
				type: "CONVERT_INVOICES_TO_DRAFT",
				status: "PROCESSING",
				createdAt: "2025-06-28T16:47:00Z",
				requestedIds: ["018ee663-e185-7b2c-9373-28c97e26f7f9"],
				completedIds: ["018ee663-e185-7b2c-9373-28c97e26f7f9"],
				failedIds: [],
				skippedIds: []
			}
		}
	})
}, qr = { deleteNotificationPolicyRecipients: n({
	route: ({ id: e, recipient: t }) => `/notifications/policies/${e}/recipients${i({ recipient: t })}`,
	method: "DELETE",
	invalidateQueries: ["notificationsPolicies"],
	mocking: {
		match: /\/api\/notifications\/policies\/([^/]+)\/recipients(\?(.*))?$/,
		mock: {
			id: "9c4c54e7-59da-44ae-9cc5-7fd81be7c133",
			createdAt: "2022-06-28T16:47:00Z",
			sequenceAccountId: "c4602d51-0fb4-4b48-b689-6ba28f540d1e",
			name: "Finance team emails",
			notificationTypes: ["CUSTOMER_CREATED"],
			recipients: ["finance@example.com"],
			channel: "EMAIL"
		}
	}
}) }, Jr = {
	getManualPaymentEligibility: t({
		route: ({ invoiceId: e }) => `/invoices/${e}/transactions/payments/eligibility`,
		queryKey: ["manualPaymentEligibility"],
		mocking: {
			match: /\/api\/invoices\/(.+)\/transactions\/payments\/eligibility$/,
			mock: {
				eligible: !0,
				reasons: []
			}
		}
	}),
	postPayment: n({
		route: () => "/payments",
		method: "POST",
		body: ({ body: e }) => JSON.stringify(e),
		headers: ({ idempotencyKey: e }) => ({ "Idempotency-Key": e ?? crypto.randomUUID() }),
		invalidateQueries: ["payments", c],
		mocking: {
			match: /\/api\/payments$/,
			mock: {
				id: "af60cab3-812d-4250-a051-0fb7133a00c7",
				invoiceId: "61b083e0-1faa-47ca-9aeb-6205da8f6c47",
				amount: "50.00",
				currency: "USD",
				paymentDate: "2026-06-01T00:00:00Z",
				allocatedAt: "2026-06-01T00:00:00Z",
				reference: "BACS FT26153001",
				invoiceBalance: {
					value: "0.00",
					currency: "USD",
					version: 2
				}
			}
		}
	})
}, Yr = {
	getManualTask: t({
		route: ({ id: e }) => `/watchtower/manual-tasks/${e}`,
		queryKey: [v],
		mocking: {
			match: /\/api\/watchtower\/manual-tasks\/(.+)$/,
			mock: {
				id: "test-manual-task-1",
				type: "QUOTE_APPROVAL",
				input: {
					quote: {
						...y.getQuote.mocking.mock,
						id: "1",
						title: "Quote 1",
						quoteNumber: "Q00001",
						customerId: y.getCustomer.mocking.mock.id
					},
					requestor: y.getUser.mocking.mock,
					customer: y.getCustomer.mocking.mock,
					comment: "APPROVE PLZ"
				},
				status: "PENDING",
				createdAt: "2026-06-02T12:00:00.000Z",
				updatedAt: "2026-06-02T12:00:00.000Z",
				assignmentRules: {},
				executorWorkflowExecutionId: "executorWorkflowExecutionId-1",
				executorTaskId: "executorTaskId-1"
			}
		}
	}),
	getManualTasks: t({
		route: (e) => `/watchtower/manual-tasks${i(e)}`,
		queryKey: [v],
		mocking: {
			match: /\/api\/watchtower\/manual-tasks(\?(.*))?$/,
			mock: {
				items: Array.from({ length: 100 }).map((e, t) => ({
					id: `test-manual-task-${t}`,
					type: "QUOTE_APPROVAL",
					input: {
						quote: {
							...y.getQuote.mocking.mock,
							id: `${t}`,
							title: `Quote ${t}`,
							quoteNumber: `Q0000${t}`,
							customerId: y.getCustomer.mocking.mock.id
						},
						requestor: y.getUser.mocking.mock,
						customer: y.getCustomer.mocking.mock,
						comment: "APPROVE PLZ"
					},
					status: "PENDING",
					createdAt: "2024-01-01T12:00:00.000Z",
					updatedAt: "2024-01-01T12:00:00.000Z",
					assignmentRules: {},
					executorWorkflowExecutionId: `executorWorkflowExecutionId-${t}`,
					executorTaskId: `executorTaskId-${t}`
				})),
				pagination: {
					before: "cursor-123",
					after: "",
					totalResultSize: 100
				}
			}
		}
	}),
	getAdminManualTasks: t({
		route: ({ before: e, ...t } = {}) => `/watchtower/admin/manual-tasks${i(t)}`,
		queryKey: [_],
		mocking: {
			match: /\/api\/watchtower\/admin\/manual-tasks(\?(.*))?$/,
			mock: {
				items: Array.from({ length: 100 }).map((e, t) => ({
					id: `test-manual-task-${t}`,
					type: "QUOTE_APPROVAL",
					input: {
						quote: {
							...y.getQuote.mocking.mock,
							id: `${t}`,
							title: `Quote ${t}`,
							quoteNumber: `Q0000${t}`,
							customerId: y.getCustomer.mocking.mock.id
						},
						requestor: y.getUser.mocking.mock,
						customer: y.getCustomer.mocking.mock,
						comment: "APPROVE PLZ"
					},
					status: "PENDING",
					createdAt: "2024-01-15T10:00:00Z",
					updatedAt: "2024-01-15T10:00:00Z",
					assignmentRules: {},
					executorWorkflowExecutionId: `executorWorkflowExecutionId-${t}`,
					executorTaskId: `executorTaskId-${t}`
				})),
				pagination: {
					before: "cursor-123",
					after: "",
					totalResultSize: 100
				}
			}
		}
	}),
	postCompleteManualTask: n({
		method: "POST",
		route: ({ id: e }) => `/watchtower/manual-tasks/${e}/complete`,
		body: ({ outputData: e }) => JSON.stringify({ outputData: e }),
		invalidateQueries: [v, _],
		mocking: {
			match: /\/api\/watchtower\/manual-tasks\/(.+)\/complete$/,
			mock: void 0
		}
	}),
	postCancelManualTask: n({
		method: "POST",
		route: ({ id: e }) => `/watchtower/manual-tasks/${e}/cancel`,
		invalidateQueries: [v, _],
		mocking: {
			match: /\/api\/watchtower\/manual-tasks\/(.+)\/cancel$/,
			mock: void 0
		}
	}),
	postMarkManualTaskAsRead: n({
		method: "POST",
		route: ({ id: e }) => `/watchtower/manual-tasks/${e}/mark-as-read`,
		invalidateQueries: [v, _],
		mocking: {
			match: /\/api\/watchtower\/manual-tasks\/(.+)\/mark-as-read$/,
			mock: null,
			status: 204
		}
	}),
	getAutomation: t({
		route: ({ id: e }) => `/watchtower/automations/${e}`,
		queryKey: [p],
		mocking: {
			match: /\/api\/watchtower\/automations\/(.+)$/,
			mock: {
				id: "test-automation-1",
				name: "Quote Approval Workflow",
				description: "Automated workflow for quote approval process",
				createdAt: "2024-01-01T00:00:00Z",
				createdBy: "user-1",
				updatedAt: "2024-01-15T00:00:00Z",
				sequenceAccountId: "account-1"
			}
		}
	}),
	getAutomations: t({
		route: (e) => `/watchtower/automations${i(e)}`,
		queryKey: [p],
		mocking: {
			match: /\/api\/watchtower\/automations(\?(.*))?$/,
			mock: {
				items: Array.from({ length: 5 }).map((e, t) => ({
					id: `test-automation-${t + 1}`,
					name: `Quote approvals ${t + 1}`,
					description: "Routes quotes for approval or immediate publishing based on the contract value.",
					createdAt: "2026-01-26T12:01:00.000Z",
					createdBy: "user-1",
					updatedAt: "2026-01-26T12:01:00.000Z",
					sequenceAccountId: "account-1"
				})),
				pagination: {
					before: "cursor-123",
					after: "",
					totalResultSize: 5
				}
			}
		}
	}),
	postAutomation: n({
		method: "POST",
		route: () => "/watchtower/automations",
		body: (e) => JSON.stringify(e),
		invalidateQueries: [p],
		mocking: {
			match: /\/api\/watchtower\/automations$/,
			mock: {
				id: "test-automation-1",
				name: "Quote approvals 1",
				description: "Routes quotes for approval or immediate publishing based on the contract value.",
				createdAt: "2026-01-26T12:01:00.000Z",
				createdBy: "user-1",
				updatedAt: "2026-01-26T12:01:00.000Z",
				sequenceAccountId: "account-1"
			}
		}
	}),
	patchAutomation: n({
		method: "PATCH",
		route: ({ id: e }) => `/watchtower/automations/${e}`,
		body: ({ body: e }) => JSON.stringify(e),
		invalidateQueries: [p],
		mocking: {
			match: /\/api\/watchtower\/automations\/(.+)$/,
			mock: {
				id: "test-automation-1",
				name: "Quote Approval Workflow",
				description: "Automated workflow for quote approval process",
				createdAt: "2024-01-01T00:00:00Z",
				createdBy: "user-1",
				updatedAt: "2024-01-15T00:00:00Z",
				sequenceAccountId: "account-1"
			}
		}
	}),
	getAutomationVersion: t({
		route: ({ automationId: e, versionId: t }) => `/watchtower/automations/${e}/versions/${t}`,
		queryKey: [h],
		mocking: {
			match: /\/api\/watchtower\/automations\/(.+)\/versions\/(.+)$/,
			mock: {
				id: "test-version-1",
				automationId: "test-automation-1",
				versionNumber: "1",
				changelog: "Initial version",
				presentation: {},
				workflowDefinition: {},
				conductorWorkflowDefinitionId: "conductor-def-1",
				conductorWorkflowDefinitionVersion: "1",
				triggerType: "QUOTE_REQUIRES_APPROVAL",
				active: !0,
				createdAt: "2024-01-01T00:00:00Z",
				createdBy: "user-1",
				createdByEmail: "user-1@example.com"
			}
		}
	}),
	postAutomationVersion: n({
		method: "POST",
		route: ({ automationId: e }) => `/watchtower/automations/${e}/versions`,
		body: ({ body: e }) => JSON.stringify(e),
		invalidateQueries: [h],
		mocking: {
			match: /\/api\/watchtower\/automations\/(.+)\/versions$/,
			mock: {
				id: "test-version-1",
				automationId: "test-automation-1",
				versionNumber: "1",
				changelog: "Initial version",
				presentation: {},
				workflowDefinition: {},
				conductorWorkflowDefinitionId: "conductor-def-1",
				conductorWorkflowDefinitionVersion: "1",
				triggerType: "QUOTE_REQUIRES_APPROVAL",
				active: !0,
				createdAt: "2026-02-20T12:00:00.000Z",
				createdBy: "user-1",
				createdByEmail: "user-1@example.com"
			}
		}
	}),
	getAutomationVersions: t({
		route: ({ automationId: e, before: t, ...n }) => `/watchtower/automations/${e}/versions${i(n)}`,
		queryKey: [h],
		mocking: {
			match: /\/api\/watchtower\/automations\/(.+)\/versions(\?(.*))?$/,
			mock: {
				items: [{
					id: "test-version-1",
					automationId: "test-automation-1",
					versionNumber: "1",
					changelog: "Initial version",
					presentation: {},
					workflowDefinition: {},
					conductorWorkflowDefinitionId: "conductor-def-1",
					conductorWorkflowDefinitionVersion: "1",
					triggerType: "QUOTE_REQUIRES_APPROVAL",
					active: !0,
					createdAt: "2024-01-01T00:00:00Z",
					createdBy: "user-1",
					createdByEmail: "user-1@example.com"
				}],
				pagination: {
					before: "cursor-123",
					after: "",
					totalResultSize: 1
				}
			}
		}
	}),
	getAllAutomationVersions: t({
		route: (e) => `/watchtower/automation-versions${i(e)}`,
		queryKey: [h],
		mocking: {
			match: /\/api\/watchtower\/automation-versions(\?(.*))?$/,
			mock: {
				items: Array.from({ length: 5 }).map((e, t) => ({
					id: `automation-version-${t + 1}`,
					automationId: `automation-${Math.floor(t / 2) + 1}`,
					versionNumber: String(t % 3 + 1),
					changelog: t === 0 ? "Initial version" : `Update ${t}`,
					presentation: {},
					workflowDefinition: {},
					conductorWorkflowDefinitionId: "cpq-approval-workflow",
					conductorWorkflowDefinitionVersion: String(t % 3 + 1),
					triggerType: t % 2 == 0 ? "QUOTE_REQUIRES_APPROVAL" : "CONTRACT_UPLOADED",
					active: t === 0 || t === 2,
					createdAt: "2024-01-01T00:00:00Z",
					createdBy: "user-1",
					createdByEmail: "user-1@example.com"
				})),
				pagination: {
					before: "cursor-before-123",
					after: "cursor-after-456",
					totalResultSize: 5
				}
			}
		}
	}),
	postArchiveAutomation: n({
		method: "POST",
		route: ({ id: e }) => `/watchtower/automations/${e}/archive`,
		invalidateQueries: [p],
		mocking: {
			match: /\/api\/watchtower\/automations\/(.+)\/archive$/,
			mock: {
				id: "test-automation-1",
				name: "Quote Approval Workflow",
				description: "Automated workflow for quote approval process",
				createdAt: "2024-01-01T00:00:00Z",
				createdBy: "user-1",
				updatedAt: "2024-01-15T00:00:00Z",
				sequenceAccountId: "account-1"
			}
		}
	}),
	postActivateAutomationVersion: n({
		method: "POST",
		route: ({ automationId: e, versionId: t }) => `/watchtower/automations/${e}/versions/${t}/activate`,
		invalidateQueries: [h],
		mocking: {
			match: /\/api\/watchtower\/automations\/(.+)\/versions\/(.+)\/activate$/,
			mock: {
				id: "test-version-1",
				automationId: "test-automation-1",
				versionNumber: "1",
				changelog: "Initial version",
				presentation: {},
				workflowDefinition: {},
				conductorWorkflowDefinitionId: "conductor-def-1",
				conductorWorkflowDefinitionVersion: "1",
				triggerType: "QUOTE_REQUIRES_APPROVAL",
				active: !0,
				createdAt: "2024-01-01T00:00:00Z",
				createdBy: "user-1",
				createdByEmail: "user-1@example.com"
			}
		}
	}),
	postDeactivateAutomationVersion: n({
		method: "POST",
		route: ({ automationId: e, versionId: t }) => `/watchtower/automations/${e}/versions/${t}/deactivate`,
		invalidateQueries: [h],
		mocking: {
			match: /\/api\/watchtower\/automations\/(.+)\/versions\/(.+)\/deactivate$/,
			mock: {
				id: "test-version-1",
				automationId: "test-automation-1",
				versionNumber: "1",
				changelog: "Initial version",
				presentation: {},
				workflowDefinition: {},
				conductorWorkflowDefinitionId: "conductor-def-1",
				conductorWorkflowDefinitionVersion: "1",
				triggerType: "QUOTE_REQUIRES_APPROVAL",
				active: !1,
				createdAt: "2024-01-01T00:00:00Z",
				createdBy: "user-1",
				createdByEmail: "user-1@example.com"
			}
		}
	}),
	postArchiveAutomationVersion: n({
		method: "POST",
		route: ({ automationId: e, versionId: t }) => `/watchtower/automations/${e}/versions/${t}/archive`,
		invalidateQueries: [h],
		mocking: {
			match: /\/api\/watchtower\/automations\/(.+)\/versions\/(.+)\/archive$/,
			mock: {
				id: "test-version-1",
				automationId: "test-automation-1",
				versionNumber: "1",
				changelog: "Initial version",
				presentation: {},
				workflowDefinition: {},
				conductorWorkflowDefinitionId: "conductor-def-1",
				conductorWorkflowDefinitionVersion: "1",
				triggerType: "QUOTE_REQUIRES_APPROVAL",
				active: !1,
				createdAt: "2024-01-01T00:00:00Z",
				createdBy: "user-1",
				createdByEmail: "user-1@example.com"
			}
		}
	}),
	getAutomationExecutions: t({
		route: ({ before: e, ...t } = {}) => `/watchtower/automation-executions${i(t)}`,
		queryKey: [u],
		mocking: {
			match: /\/api\/watchtower\/automation-executions(\?(.*))?$/,
			mock: {
				items: [{
					id: "automation-execution-1",
					automationId: "automation-id-1",
					automationVersionId: "automation-version-id-1",
					status: "RUNNING",
					input: {},
					output: {},
					variables: {},
					tasks: [],
					createTime: "2024-01-01T00:00:00Z",
					updateTime: "2024-01-01T00:00:00Z",
					failedReferenceTaskNames: []
				}],
				pagination: {
					before: "cursor-123",
					after: "",
					totalResultSize: 5
				}
			}
		}
	}),
	getAutomationExecution: t({
		route: ({ id: e }) => `/watchtower/automation-executions/${e}`,
		queryKey: [u],
		mocking: {
			match: /\/api\/watchtower\/automation-executions\/(.+)$/,
			mock: {
				id: "automation-execution-1",
				automationId: "automation-id-1",
				automationVersionId: "automation-version-id-1",
				status: "RUNNING",
				input: {},
				output: {},
				variables: {},
				tasks: [],
				createTime: "2024-01-01T00:00:00Z",
				updateTime: "2024-01-01T00:00:00Z",
				failedReferenceTaskNames: []
			}
		}
	}),
	postCancelAutomationExecution: n({
		method: "POST",
		route: ({ id: e }) => `/watchtower/automation-executions/${e}/cancel`,
		invalidateQueries: [u],
		mocking: {
			match: /\/api\/watchtower\/automation-executions\/(.+)\/cancel$/,
			mock: void 0
		}
	}),
	postStartAutomation: n({
		method: "POST",
		route: () => "/watchtower/automations/start",
		body: (e) => JSON.stringify(e),
		invalidateQueries: [u],
		mocking: {
			match: /\/api\/watchtower\/automations\/start$/,
			mock: {
				id: "automation-execution-1",
				automationId: "automation-id-1",
				automationVersionId: "automation-version-id-1",
				status: "RUNNING",
				input: {},
				output: {},
				variables: {},
				tasks: [],
				createTime: "2024-01-01T00:00:00Z",
				updateTime: "2024-01-01T00:00:00Z",
				failedReferenceTaskNames: []
			}
		}
	})
}, Xr = ee({
	endpoints: {
		getProduct: ge,
		getProducts: _e,
		postProduct: ve,
		putProduct: ye,
		getTaxCategories: be,
		postSetTaxCategoryAsDefault: we,
		getTaxRates: xe,
		postNewTaxRateVersion: Ee,
		postNewTaxCategoryVersion: Ce,
		postTaxCategory: Se,
		postTaxRate: Te,
		getJournal: je,
		getAccountingPeriods: Me,
		getLedgers: Ne,
		getLedger: Pe,
		getRevRecChartsData: Fe,
		postJournalReport: Ie,
		postJournalPushToXero: Le,
		getJournalPushXeroSyncStatus: Re,
		postAnalysisReport: ze,
		getAnalysisReportSignedDownload: Be,
		postDeferredRevenueScheduleReport: Ve,
		getDeferredRevenueScheduleSignedDownload: He,
		getEnabledTaxIntegration: Ge,
		putEnabledTaxIntegration: Ke,
		getAllAvalaraCompanies: We,
		postEnabledAvalaraCompany: Xe,
		getAllTaxCategoriesWithAvalaraMappings: qe,
		postTaxCategoryAvalaraMapping: Je,
		deleteTaxCategoryAvalaraMapping: Ye,
		postTestAvalaraCredentials: Ze,
		postStoreAvalaraCredentials: Qe,
		getStoredAvalaraCredentials: $e,
		postTestNumeralCredentials: tt,
		postStoreNumeralCredentials: nt,
		getStoredNumeralCredentials: rt,
		postTestSphereCredentials: it,
		postStoreSphereCredentials: at,
		getStoredSphereCredentials: ot,
		postTestAnrokCredentials: ct,
		postStoreAnrokCredentials: lt,
		getStoredAnrokCredentials: ut,
		postTestRilletCredentials: ft,
		postStoreRilletCredentials: pt,
		getStoredRilletCredentials: mt,
		putStoreRilletWebhookToken: ht,
		getStoredRilletWebhookToken: gt,
		postHubspotDealQuote: vt,
		getAllTaxCategoriesWithNumeralMappings: yt,
		getNumeralTaxCategories: bt,
		postTaxCategoryNumeralMapping: xt,
		putTaxCategoryNumeralMapping: St,
		deleteTaxCategoryNumeralMapping: Ct,
		getAllTaxCategoriesWithAnrokMappings: wt,
		getAnrokTaxCategories: Tt,
		postTaxCategoryAnrokMapping: Et,
		putTaxCategoryAnrokMapping: Dt,
		deleteTaxCategoryAnrokMapping: Ot,
		getAvalaraTaxCodeInfo: kt,
		getDeferredRevenueSchedule: At,
		postRecognizeMilestoneRevenue: jt,
		getCreditNote: Mt,
		getCreditNotes: Pt,
		getCreditNoteApplicationEligibility: Ft,
		deleteCreditNote: It,
		postCreditNote: Lt,
		putCreditNote: Zt,
		postFinalizeAndSendCreditNote: Rt,
		postFinalizeCreditNote: zt,
		postVoidCreditNote: Vt,
		postSendCreditNote: Bt,
		postSendTestCreditNote: Ht,
		postMarkAsSentCreditNote: Jt,
		postCreditNoteApplication: Yt,
		postRecalculateCreditNote: Xt,
		getCreditNoteLineItems: Qt,
		postCreditNoteLineItem: $t,
		putCreditNoteLineItem: en,
		deleteCreditNoteLineItem: tn,
		getCreditNoteLineItemGroups: nn,
		postCreditNoteLineItemGroup: rn,
		putCreditNoteLineItemGroup: an,
		deleteCreditNoteLineItemGroup: on,
		getDownloadCreditNotePdf: Nt,
		getCustomer: cn,
		postCustomer: ln,
		putCustomer: un,
		getCustomers: dn,
		getCustomersLabels: fn,
		postManualJournal: pn,
		getStripeCollectionsSettings: mn,
		putStripeCollectionsSettings: hn,
		postPushBillingScheduleToExternalService: vn,
		getBillingSchedule: yn,
		getQuickbooksAccounts: Sn,
		postPushProductToQuickbooks: Cn,
		getQuickbooksTaxCodes: wn,
		getDefaultQuickbooksTaxCodes: Tn,
		putDefaultQuickbooksTaxCodes: En,
		getDefaultQuickbooksAccount: Dn,
		putDefaultQuickbooksAccount: On,
		getQuickbooksTaxCodeMappings: kn,
		postQuickbooksTaxCodeMapping: An,
		getJournalsPaginated: jn,
		getRevenueRecognitionOverview: Mn,
		getDeferredRevenueSchedulesPaginated: Nn,
		getRevenueWaterfallData: Pn,
		postWaterfallReport: Fn,
		getWaterfallReportSignedDownload: In,
		getBillingSchedulesCsvDownload: Vn,
		getXeroLedgerAccountMappings: Ln,
		postXeroLedgerAccountMapping: Rn,
		putXeroLedgerAccountMapping: zn,
		deleteXeroLedgerAccountMapping: Bn,
		getEntityTypeSyncToggles: Wt,
		postEntityTypeSyncToggle: Gt,
		putEntityTypeSyncToggle: Kt,
		deleteEntityTypeSyncToggle: qt,
		...qn,
		...$n,
		...dr,
		...Dr,
		...Nr,
		...Vr,
		...Kr,
		...Jr,
		...qr,
		...fr,
		...Wr,
		...Yr,
		...gn,
		...pr,
		...hr,
		...Tr
	},
	version: "9999-01-01"
});
//#endregion
export { Xr as t };

//# sourceMappingURL=v99990101-BAHO7XXd.js.map